const allContents = [
    {
      priority: 2,
      _id: "6040ee5bcd0316041aca768a",
      phase: "Discovery",
      level: 1,
      module: 1,
      title: "What is Digital Marketing: Tutorial for Beginners",
      link: "https://www.youtube.com/watch?v=XDpwDwcXGoU",
      type: "VIDEO",
      img: "https://img.youtube.com/vi/XDpwDwcXGoU/default.jpg",
      expression: "(*/[Newbie])-(*)-(*)-(*)-(*)-(*)"
    },
    {
      priority: 7,
      _id: "6040ee5bcd0316041aca768f",
      phase: "Discovery",
      level: 1,
      module: 1,
      title:
        "10 Reasons Why Future of Digital Marketing in India is Very Bright - Staenz",
      link: "https://staenz.com/reasons-future-digital-marketing-india-bright/",
      type: "ARTICLE",
      img:
        "https://staenz.com/wp-content/uploads/2018/03/digital-marketing-future.jpg",
      expression: "(*/[Newbie])-(*)-(*)-(*)-(*)-(*)"
    },
    {
      priority: 4,
      _id: "6040ee5bcd0316041aca768c",
      phase: "Discovery",
      level: 1,
      module: 1,
      title: "Should You Choose a Career in Digital Marketing? | DMI",
      link:
        "https://digitalmarketinginstitute.com/blog/should-you-choose-a-career-in-digital-marketing",
      type: "ARTICLE",
      img:
        "https://digitalmarketinginstitute.com/assets-v3/images/design/logo-full.png",
      expression:
        "(*/[Newbie,Beginner])-(*)-(*)-(*/[Freelancing,Job,Promotion])-(*)-(*)"
    },
    {
      priority: 1,
      _id: "60b481b307168119a3c24db8",
      phase: "Discovery",
      level: 1,
      module: 1,
      title: "Marketing Psychology",
      link: "https://www.canva.com/learn/definition-marketing-psychology-use/",
      type: "ARTICLE",
      img:
        "https://static-cse.canva.com/blob/133130/The-definition-of-marketing-psychology-and-how-to-use-it-Featured-Image.c1733682.jpg",
      expression: "(*/[Newbie,Beginner])-(*)-(*)-(*)-(*)-(*)"
    },
    {
      priority: 3,
      _id: "6040ee5bcd0316041aca768b",
      phase: "Discovery",
      level: 1,
      module: 1,
      title: "A Day in the Life of a Digital Marketer - Best Marketing Degrees",
      link: "https://www.bestmarketingdegrees.org/digital-marketer/",
      type: "ARTICLE",
      img:
        "https://www.bestmarketingdegrees.org/wp-content/uploads/2015/02/digital-marketer.jpg",
      expression: "(*/[Newbie,Beginner])-(*)-(*)-(*)-(*)-(*)"
    },
    {
      priority: 5,
      _id: "6040ee5bcd0316041aca768d",
      phase: "Discovery",
      level: 1,
      module: 1,
      title:
        "Digital Marketing Roles in India | Digital Marketing Career and Job Roles | Karan Dharamsi - YouTube",
      link: "https://www.youtube.com/watch?v=MKY89RqcbHg",
      type: "VIDEO",
      img: "",
      expression: "(*/[Newbie,Beginner])-(*)-(*)-(*)-(*)-(*)"
    },
    {
      priority: 6,
      _id: "6040ee5bcd0316041aca768e",
      phase: "Discovery",
      level: 1,
      module: 1,
      title:
        "Digital Marketing Salary in India 2020 - Average to Highest | upGrad blog",
      link: "https://www.upgrad.com/blog/digital-marketing-salary-in-india/",
      type: "ARTICLE",
      img:
        "https://www.upgrad.com/blog/wp-content/uploads/2019/08/DM-Image-1.png",
      expression: "(*/[Newbie,Beginner])-(*)-(*)-(*)-(*)-(*)"
    },
    {
      priority: 8,
      _id: "6040ee5bcd0316041aca7690",
      phase: "Discovery",
      level: 1,
      module: 1,
      title:
        "MARKETING CAREER GUIDE | Difference between B2B and B2C Marketing, Full-Time vs. Remote and more - YouTube",
      link: "https://www.youtube.com/watch?v=vDOkpkBfj_I",
      type: "VIDEO",
      img: "",
      expression: "(*/[Newbie,Beginner])-(*)-(*)-(*)-(*)-(*)"
    },
    {
      priority: 9,
      _id: "60b231987b12b9618204e7cd",
      phase: "Learning",
      level: 1,
      module: 1,
      title: "How to Start a Career in Digital Marketing",
      link: "https://www.youtube.com/watch?v=DoLzQN1m7sU",
      type: "VIDEO",
      img: "undefined",
      expression: "(*^[Advanced])-(*)-(*)-(*)-(*)-(*)"
    },
    {
      priority: 10,
      _id: "6040ee5bcd0316041aca7692",
      phase: "Learning",
      level: 1,
      module: 1,
      title: "Social Media Campaign Examples",
      link: "https://www.youtube.com/watch?v=IQfZPsCVbTU",
      type: "VIDEO",
      img: null,
      expression: "(*^[Advanced])-(*)-(*)-(*)-(*)-(*)"
    },
    {
      priority: 11,
      _id: "60b481b407168119a3c24dd5",
      phase: "Learning",
      level: 1,
      module: 1,
      title: "Guide to Small Business",
      link:
        "https://www.canva.com/learn/the-beginners-guide-to-small-business-marketing-online/",
      type: "ARTICLE",
      img:
        "https://static-cse.canva.com/blob/132836/Beginners-Guide-to-Small-Business-Marketing-Online-Featured-Image.dcdf4060.jpg",
      expression: "(*^[Advanced])-(*)-(*)-(*)-(*)-(*)"
    },
    {
      priority: 13,
      _id: "6040ee5bcd0316041aca7693",
      phase: "Learning",
      level: 1,
      module: 1,
      title: "Marketing Funnels",
      link: "https://www.canva.com/learn/how-marketing-funnels-work/",
      type: "ARTICLE",
      img:
        "https://static-cse.canva.com/blob/132976/funnel-machine-fa.1ada92d2.png",
      expression: "(*^[Advanced])-(*)-(*)-(*)-(*)-(*)"
    },
    {
      priority: 12,
      _id: "60422b53334ba439684e57a6",
      phase: "Learning",
      level: 1,
      module: 1,
      title: "Know How Digital Marketing is Important for Business",
      link: "https://www.youtube.com/watch?v=q_eRGM9FZDM",
      type: "VIDEO",
      img: "undefined",
      expression: "(*^[Advanced])-(*)-(*)-(*)-(*)-(*)"
    },
    {
      priority: 15,
      _id: "6040ee5bcd0316041aca7694",
      phase: "Learning",
      level: 2,
      module: 1,
      title: "5 P's of Marketing - Learn More About the Marketing Mix",
      link:
        "https://corporatefinanceinstitute.com/resources/knowledge/other/5-ps-marketing/",
      type: "ARTICLE",
      img:
        "https://cdn.corporatefinanceinstitute.com/assets/5ps-marketing-1024x496.png",
      expression: "(*^[Advanced])-(*)-(*)-(*)-(*)-(*)"
    },
    {
      priority: 16,
      _id: "6040ee5bcd0316041aca7695",
      phase: "Learning",
      level: 2,
      module: 1,
      title: "The AIDA Model and The Marketing Funnel",
      link: "https://youtu.be/R5-LsY5dCSs",
      type: "VIDEO",
      img: null,
      expression: "(*^[Advanced])-(*)-(*)-(*)-(*)-(*)"
    },
    {
      priority: 17,
      _id: "60b231997b12b9618204e7d8",
      phase: "Learning",
      level: 2,
      module: 1,
      title: "Build your Buyer Persona",
      link: "https://www.youtube.com/watch?v=o-xAc1H6vlg",
      type: "VIDEO",
      img: "undefined",
      expression: "(*^[Advanced])-(*)-(*)-(*)-(*)-(*)"
    },
    {
      priority: 23,
      _id: "60422b53334ba439684e57aa",
      phase: "Learning",
      level: 1,
      module: 3,
      title: "Using Facebook for Business Growth",
      link:
        "https://www.facebook.com/business/learn/lessons/how-business-owners-can-use-facebook?course_id=1042513649280895&curriculum_id=434503597101154",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*/[Newbie,Beginner])-OR(*/[Content Marketing,Social Media,Account Management,Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 26,
      _id: "60422b53334ba439684e57ab",
      phase: "Learning",
      level: 1,
      module: 3,
      title: "Creating Facebook Page to Promote your Business",
      link:
        "https://www.facebook.com/business/learn/lessons/tips-to-creating-a-facebook-page?course_id=1254846341356301&curriculum_id=434503597101154",
      type: "ARTICLE",
      img:
        "https://assets.entrepreneur.com/images/misc/1586179849_word-image-1179.png",
      expression:
        "(*/[Newbie,Beginner])-OR(*/[Content Marketing,Social Media,Account Management,Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 33,
      _id: "6040ee5bcd0316041aca7696",
      phase: "Learning",
      level: 1,
      module: 3,
      title: "Creating an Organic Social Strategy",
      link:
        "https://www.socialpilot.co/blog/how-to-create-an-organic-social-strategy",
      type: "ARTICLE",
      img:
        "https://www.socialpilot.co/hs-fs/hubfs/convincepct20andpct20convert.jpg?width=684&height=348&name=convincepct20andpct20convert.jpg",
      expression:
        "(*)-OR(*/[Content Marketing,Social Media,Account Management,Paid Advertising])-OR(*/[Social Media,Content Marketing])-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 20,
      _id: "60422b53334ba439684e57a8",
      phase: "Learning",
      level: 1,
      module: 3,
      title: "Social Media Marketing Basics",
      link: "https://www.youtube.com/watch?v=I2pwcAVonKI",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Content Marketing,Social Media,Account Management,Paid Advertising])-OR(*/[Social Media,Content Marketing])-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 21,
      _id: "60422b53334ba439684e57a9",
      phase: "Learning",
      level: 1,
      module: 3,
      title: "Social Media Marketing (Step-by-Step) for Beginners",
      link: "https://www.youtube.com/watch?v=YD-kgwtqhTY",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Content Marketing,Social Media,Account Management,Paid Advertising])-OR(*/[Social Media,Content Marketing])-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 29,
      _id: "60422b53334ba439684e57ae",
      phase: "Learning",
      level: 1,
      module: 3,
      title: "Instagram Marketing",
      link: "https://www.youtube.com/watch?v=JseRpiYfcRw",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Content Marketing,Social Media,Account Management,Paid Advertising])-OR(*/[Social Media,Content Marketing])-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 30,
      _id: "60422b53334ba439684e57af",
      phase: "Learning",
      level: 1,
      module: 3,
      title: "Linkedin Marketing",
      link: "https://www.youtube.com/watch?v=QOCqsKAKM4s",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Content Marketing,Social Media,Account Management,Paid Advertising])-OR(*/[Social Media,Content Marketing])-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 31,
      _id: "60b231987b12b9618204e7b2",
      phase: "Learning",
      level: 1,
      module: 3,
      title: "The Ultimate Guide To Twitter 2018",
      link: "https://www.theedublogger.com/twitter/",
      type: "ARTICLE",
      img:
        "https://www.theedublogger.com/files/2018/10/Should-You-Use-Twitter-Sylvia-Duckworth-ud8cm1-1uuh0vi.jpg",
      expression:
        "(*)-OR(*/[Content Marketing,Social Media,Account Management,Paid Advertising])-OR(*/[Social Media,Content Marketing])-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 32,
      _id: "60422b53334ba439684e57b0",
      phase: "Learning",
      level: 1,
      module: 3,
      title: "Best Digital Marketing Tools",
      link: "https://www.youtube.com/watch?v=kc_GY47_1Ng",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Content Marketing,Social Media,Account Management,Paid Advertising])-OR(*/[Social Media,Content Marketing])-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 34,
      _id: "60b231987b12b9618204e7c2",
      phase: "Learning",
      level: 1,
      module: 3,
      title: "The Best Times to Post on Social Media in 2020 | Sprout Social",
      link:
        "https://sproutsocial.com/insights/best-times-to-post-on-social-media/",
      type: "ARTICLE",
      img:
        "https://media.sproutsocial.com/uploads/2020/08/best-times-to-post-2021-feature-image.png",
      expression:
        "(*)-OR(*/[Content Marketing,Social Media,Account Management,Paid Advertising])-OR(*/[Social Media,Content Marketing])-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 1,
      _id: "60b481b407168119a3c24de0",
      phase: "Learning",
      level: 2,
      module: 3,
      title: "Mastering Social Media",
      link: "https://youtu.be/ztM72Bt7g7k",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 2,
      _id: "60b481b407168119a3c24de5",
      phase: "Learning",
      level: 2,
      module: 3,
      title: "Build your focus",
      link: "https://youtu.be/f_CoCjUpbFQ",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 3,
      _id: "60b481b407168119a3c24dea",
      phase: "Learning",
      level: 2,
      module: 3,
      title: "Set your goals",
      link: "https://youtu.be/uD1dZdx3tkY",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 4,
      _id: "60b481b407168119a3c24def",
      phase: "Learning",
      level: 2,
      module: 3,
      title: "Define your style",
      link: "https://youtu.be/UNFpzQZ_xNY",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 5,
      _id: "60b481b507168119a3c24df3",
      phase: "Learning",
      level: 2,
      module: 3,
      title: "Make it visual",
      link: "https://youtu.be/NFzFFF1qphs",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 6,
      _id: "60b481b507168119a3c24df9",
      phase: "Learning",
      level: 2,
      module: 3,
      title: "Color, contrast & clarity",
      link: "https://youtu.be/F5Espc0vBAE",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 7,
      _id: "60b481b507168119a3c24dfe",
      phase: "Learning",
      level: 2,
      module: 3,
      title: "Master your videos",
      link: "https://youtu.be/45Kcp8z1YSM",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 8,
      _id: "60b481b507168119a3c24e03",
      phase: "Learning",
      level: 2,
      module: 3,
      title: "Tailor your content",
      link: "https://youtu.be/SxWHaAVSVyM",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 9,
      _id: "60b481b507168119a3c24e09",
      phase: "Learning",
      level: 2,
      module: 3,
      title: "Educate, inspire, entertain",
      link: "https://youtu.be/Xmxjs66e1C4",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 10,
      _id: "60b481b507168119a3c24e0d",
      phase: "Learning",
      level: 2,
      module: 3,
      title: "Plan ahead",
      link: "https://youtu.be/ztcSCcRIfWc",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 11,
      _id: "60b481b507168119a3c24e12",
      phase: "Learning",
      level: 2,
      module: 3,
      title: "Build your community",
      link: "https://youtu.be/GfDznbkpsr4",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 12,
      _id: "60b481b507168119a3c24e15",
      phase: "Learning",
      level: 2,
      module: 3,
      title: "Make your mark",
      link: "https://youtu.be/MZ2SwbbLIfc",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 13,
      _id: "60b728e2fe14f6322ad98e36",
      phase: "Learning",
      level: 3,
      module: 3,
      title: "Facebook ad options",
      link: "https://play.vidyard.com/kDuh6qSJensBpaQn6bnk6W?",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 37,
      _id: "6040ee5bcd0316041aca7697",
      phase: "Learning",
      level: 3,
      module: 3,
      title:
        "Facebook Ads: The Complete Guide to Getting Started with Facebook Ads",
      link: "https://buffer.com/library/facebook-ads",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQGBQ_eEugbXz2b_Zgho5XQP2XMGt69Sp9ocw&usqp=CAU",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 38,
      _id: "60b728e2fe14f6322ad98e3d",
      phase: "Learning",
      level: 3,
      module: 3,
      title: "Google ad options",
      link: "https://play.vidyard.com/7UTqAfaQvhnizxtvcEiPqz?",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 39,
      _id: "6040ee5bcd0316041aca7698",
      phase: "Learning",
      level: 3,
      module: 3,
      title: "Instagram Advertising: 6 Steps to Successful Ad Campaigns",
      link: "https://sproutsocial.com/insights/instagram-advertising/",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR6Ll8lHsGg8LO0ZdFaUxL0ISRedwbpg_xH0w&usqp=CAU",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 40,
      _id: "6040ee5bcd0316041aca7699",
      phase: "Learning",
      level: 3,
      module: 3,
      title:
        "How to Advertise on LinkedIn in 5 Simple Steps | LinkedIn Marketing Solutions",
      link:
        "https://business.linkedin.com/marketing-solutions/how-to-advertise-on-linkedin",
      type: "ARTICLE",
      img:
        "https://business.linkedin.com/content/dam/me/business/en-us/linkedin-logo.png",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 41,
      _id: "6040ee5bcd0316041aca769a",
      phase: "Learning",
      level: 3,
      module: 3,
      title: "Twitter Ads Tutorial",
      link: "https://www.youtube.com/watch?v=ZprFvPCsOwI",
      type: "VIDEO",
      img: null,
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 42,
      _id: "60b481b207168119a3c24da6",
      phase: "Learning",
      level: 3,
      module: 3,
      title: "10 Trends to try in 2020",
      link: "https://www.canva.com/learn/social-media-trends/",
      type: "ARTICLE",
      img:
        "https://static-cse.canva.com/blob/142694/Screen-Shot-2020-05-19-at-7.21.05-am-1.004e443a.png",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 42,
      _id: "6040ee5bcd0316041aca769b",
      phase: "Learning",
      level: 3,
      module: 3,
      title: "Snapchat Ads Tutorial",
      link: "https://www.youtube.com/watch?v=qoVTwP9qGN8",
      type: "VIDEO",
      img: null,
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 43,
      _id: "6040ee5bcd0316041aca769c",
      phase: "Learning",
      level: 4,
      module: 3,
      title: "How To Master Facebook Business Manager (the 2020 Guide)",
      link: "https://adespresso.com/blog/facebook-business-manager-guide/",
      type: "ARTICLE",
      img:
        "https://adespresso.com/wp-content/uploads/2020/05/fb-business-manager-guide-2020-1024x536.jpg",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 44,
      _id: "6040ee5bcd0316041aca769d",
      phase: "Learning",
      level: 4,
      module: 3,
      title: "Social Media Metrics",
      link: "https://www.youtube.com/watch?v=if69s7576SY",
      type: "VIDEO",
      img: null,
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 45,
      _id: "6040ee5bcd0316041aca769e",
      phase: "Learning",
      level: 4,
      module: 3,
      title: "27 Free and Paid Social Media Analytics for Marketers",
      link: "https://buffer.com/library/social-media-analytics-tools",
      type: "ARTICLE",
      img:
        "https://buffer.com/library/content/images/size/w1000/library/wp-content/uploads/2017/03/social-media-analytics-tools.jpg",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 46,
      _id: "6040ee5bcd0316041aca769f",
      phase: "Learning",
      level: 4,
      module: 3,
      title:
        "Social Media Advertising 101: How to Get the Most Out of Your Ad Budget",
      link: "https://blog.hootsuite.com/social-media-advertising/",
      type: "ARTICLE",
      img:
        "https://blog.hootsuite.com/wp-content/uploads/2020/04/social-media-advertising-statistics.jpg",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 47,
      _id: "60422b53334ba439684e57b1",
      phase: "Learning",
      level: 4,
      module: 3,
      title: "Social Media Marketing - Indian Case Studies ",
      link:
        "http://www.socialsamosa.com/category/indian-social-media-case-studies/",
      type: "ARTICLE",
      img:
        "https://www.socialsamosa.com/wp-content/uploads/2019/12/Instagram-interface-brand-creatives.jpg",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 48,
      _id: "60b728e1fe14f6322ad98e1c",
      phase: "Learning",
      level: 4,
      module: 3,
      title: "Essential Components of Social Media Strategy",
      link: "https://play.vidyard.com/ZT3Bn3VLveL99SrufrLRCe?",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 49,
      _id: "60b728e1fe14f6322ad98e23",
      phase: "Learning",
      level: 4,
      module: 3,
      title: "Conducting a Social Media Audit",
      link: "https://play.vidyard.com/PZAZxxuT95v1tEqbrqcZYi?",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 50,
      _id: "60b728e2fe14f6322ad98e29",
      phase: "Learning",
      level: 4,
      module: 3,
      title: "Budgeting for a social media program",
      link: "https://play.vidyard.com/aUcYtqc7eRS78uKiqsmBX5?",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 51,
      _id: "60b728e2fe14f6322ad98e2e",
      phase: "Learning",
      level: 4,
      module: 3,
      title: "Tactics & tools to consider",
      link: "https://play.vidyard.com/Z5SihM3xPnXuDvtDg5BsYc?",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 52,
      _id: "60b728e2fe14f6322ad98e41",
      phase: "Learning",
      level: 4,
      module: 3,
      title: "Linkedin: researching & Planning by network",
      link: "https://play.vidyard.com/iEch2xKwrkpnicA5CuRYrb?",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 53,
      _id: "60b728e2fe14f6322ad98e46",
      phase: "Learning",
      level: 4,
      module: 3,
      title: "Facebook business pages: researching & planning by network",
      link: "https://play.vidyard.com/N2YfBaRCyyKPvQTipFakZK?",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 54,
      _id: "60b728e2fe14f6322ad98e4a",
      phase: "Learning",
      level: 4,
      module: 3,
      title: "Instagram: researching & planning by network",
      link: "https://play.vidyard.com/3sxb33eQfPhvAeRVcte8WC?",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Paid Advertising])-OR(*/Social Media)-OR(*/[Branding,Business])-(*)-(*)"
    },
    {
      priority: 50,
      _id: "6040ee5bcd0316041aca76a0",
      phase: "Learning",
      level: 1,
      module: 2,
      title: "How to Build a Career in Content Marketing?",
      link:
        "https://www.naukri.com/blog/how-to-build-a-career-in-content-marketing/",
      type: "ARTICLE",
      img:
        "https://www.naukri.com/blog/content/images/2021/04/Hard-skills-vs-soft-skills.jpg",
      expression:
        "(*)-OR(*/[Content Marketing,Social Media,Search Engine Optimization,Account Management])-OR(*/Content Marketing)-OR(*/Branding)-(*)-(*)"
    },
    {
      priority: 52,
      _id: "6040ee5ccd0316041aca76a1",
      phase: "Learning",
      level: 1,
      module: 2,
      title: "5 Content Marketing Case Studies Every Marketer Can Learn From",
      link:
        "https://www.bitcatcha.com/blog/5-content-marketing-case-studies-every-marketer-can-learn/",
      type: "ARTICLE",
      img:
        "https://www.bitcatcha.com/wp-content/uploads/2017/06/bitcatcha-hostingspeed.jpg",
      expression:
        "(*)-OR(*/[Content Marketing,Social Media,Search Engine Optimization,Account Management])-OR(*/Content Marketing)-OR(*/Branding)-(*)-(*)"
    },
    {
      priority: 49,
      _id: "60422b53334ba439684e57b2",
      phase: "Learning",
      level: 1,
      module: 2,
      title: "What is Content Marketing",
      link: "https://www.youtube.com/watch?v=oZ5F4aknYFY",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Content Marketing,Social Media,Search Engine Optimization,Account Management])-OR(*/Content Marketing)-OR(*/Branding)-(*)-(*)"
    },
    {
      priority: 51,
      _id: "60422b53334ba439684e57b3",
      phase: "Learning",
      level: 1,
      module: 2,
      title: "Content Marketing Strategy",
      link: "https://www.youtube.com/watch?v=b5-GZwJgdrY",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Content Marketing,Social Media,Search Engine Optimization,Account Management])-OR(*/Content Marketing)-OR(*/Branding)-(*)-(*)"
    },
    {
      priority: 53,
      _id: "60b728e2fe14f6322ad98e32",
      phase: "Learning",
      level: 1,
      module: 2,
      title: "Effective best practices for sharing content",
      link: "https://play.vidyard.com/Mf4Ckivn4LRTYggXeg7rDs?",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Content Marketing,Social Media,Search Engine Optimization,Account Management])-OR(*/Content Marketing)-OR(*/Branding)-(*)-(*)"
    },
    {
      priority: 54,
      _id: "60b231987b12b9618204e7c6",
      phase: "Learning",
      level: 2,
      module: 2,
      title: "The Nine Ingredients That Make Great Content",
      link: "https://neilpatel.com/blog/ingredients-of-great-content/",
      type: "ARTICLE",
      img:
        "https://neilpatel.com/wp-content/uploads/2012/10/fearofbeingeaten.png",
      expression:
        "(*)-OR(*/[Content Marketing,Social Media])-OR(*/Content Marketing)-OR(*/Branding)-(*)-(*)"
    },
    {
      priority: 55,
      _id: "6040ee5ccd0316041aca76a2",
      phase: "Learning",
      level: 2,
      module: 2,
      title: "Content Buckets: Why You Need Them in Your 2021 Content Strategy",
      link:
        "https://wittykittydigital.com/blog/content-buckets-content-strategy/",
      type: "ARTICLE",
      img:
        "https://wittykittydigital.com/wp-content/uploads/2019/04/startup-3267505_1920-1024x683.jpg",
      expression:
        "(*)-OR(*/[Content Marketing,Social Media])-OR(*/Content Marketing)-OR(*/Branding)-(*)-(*)"
    },
    {
      priority: 56,
      _id: "6040ee5ccd0316041aca76a3",
      phase: "Learning",
      level: 2,
      module: 2,
      title: "Creating content Calendar",
      link: "https://www.youtube.com/watch?v=o5tOD7OCh8A",
      type: "VIDEO",
      img: null,
      expression:
        "(*)-OR(*/[Content Marketing,Social Media])-OR(*/Content Marketing)-OR(*/Branding)-(*)-(*)"
    },
    {
      priority: 57,
      _id: "6040ee5ccd0316041aca76a4",
      phase: "Learning",
      level: 2,
      module: 2,
      title: "The 19 Best Content Marketing Tools in 2020",
      link: "https://blog.hubspot.com/marketing/content-marketing-tools",
      type: "ARTICLE",
      img:
        "https://blog.hubspot.com/hubfs/The%2019%20Best%20Content%20Marketing%20Tools%20in%202019-9.png",
      expression:
        "(*)-OR(*/[Content Marketing,Social Media])-OR(*/Content Marketing)-OR(*/Branding)-(*)-(*)"
    },
    {
      priority: 58,
      _id: "6040ee5ccd0316041aca76a5",
      phase: "Learning",
      level: 2,
      module: 2,
      title: "How to Find Endless Content Ideas With One FREE Tool",
      link: "https://www.youtube.com/watch?v=Vt2GOyLIHWk",
      type: "VIDEO",
      img: "https://img.youtube.com/vi/Vt2GOyLIHWk/default.jpg",
      expression:
        "(*)-OR(*/[Content Marketing,Social Media])-OR(*/Content Marketing)-OR(*/Branding)-(*)-(*)"
    },
    {
      priority: 60,
      _id: "6040ee5ccd0316041aca76a6",
      phase: "Learning",
      level: 3,
      module: 2,
      title:
        "What Does Content Marketing Look Like in 2019 | Neil Patel - YouTube",
      link: "https://www.youtube.com/watch?v=tRXT58fDzjg",
      type: "VIDEO",
      img: "",
      expression:
        "(*)-OR(*/Content Marketing)-OR(*/Content Marketing)-(*)-(*)-(*)"
    },
    {
      priority: 61,
      _id: "6040ee5ccd0316041aca76a7",
      phase: "Learning",
      level: 3,
      module: 2,
      title: "The Advanced Guide to Custom Content Marketing",
      link:
        "https://neilpatel.com/blog/the-advanced-guide-to-custom-content-marketing/",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSGdQHHAeYFL24rp79ACxdBfZA9C874S1D45A&usqp=CAU",
      expression:
        "(*)-OR(*/Content Marketing)-OR(*/Content Marketing)-(*)-(*)-(*)"
    },
    {
      priority: 62,
      _id: "6040ee5ccd0316041aca76a8",
      phase: "Learning",
      level: 3,
      module: 2,
      title: "Content Marketing Made Simple: A Step-by-Step Guide",
      link: "https://neilpatel.com/what-is-content-marketing/",
      type: "ARTICLE",
      img:
        "https://neilpatel.com/wp-content/uploads/2021/05/content-marketing.png",
      expression:
        "(*)-OR(*/Content Marketing)-OR(*/Content Marketing)-(*)-(*)-(*)"
    },
    {
      priority: 63,
      _id: "6040ee5ccd0316041aca76a9",
      phase: "Learning",
      level: 3,
      module: 2,
      title:
        "The Step-by-Step Guide to Syndicating Content (Without Screwing up Your SEO)",
      link:
        "https://neilpatel.com/blog/the-step-by-step-guide-to-syndicating-content-without-screwing-up-your-seo/",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThb9vQa8hwEqFh-OIggizihjHokD73BXC-Iw&usqp=CAU",
      expression:
        "(*)-OR(*/Content Marketing)-OR(*/Content Marketing)-(*)-(*)-(*)"
    },
    {
      priority: 75,
      _id: "60b231987b12b9618204e7be",
      phase: "Learning",
      level: 1,
      module: 4,
      title: "What is SEO and How Does it Work? (2020)",
      link: "https://www.youtube.com/watch?v=D7UxlkwdYc0",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Account Management,Paid Advertising,Content Marketing])-OR(*/[Search Engine Optimization,Paid Advertising])-OR(*/[Branding,Business]-(*)-(*)"
    },
    {
      priority: 79,
      _id: "6040ee5ccd0316041aca76ad",
      phase: "Learning",
      level: 1,
      module: 4,
      title: 'Simple SEO Strategy: The "Middleman" Method - YouTube',
      link: "https://www.youtube.com/watch?v=433XlvMl508",
      type: "VIDEO",
      img: "",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Account Management,Paid Advertising,Content Marketing])-OR(*/[Search Engine Optimization,Paid Advertising])-OR(*/[Branding,Business]-(*)-(*)"
    },
    {
      priority: 80,
      _id: "60b231987b12b9618204e7d4",
      phase: "Learning",
      level: 1,
      module: 4,
      title: "Types of SEO",
      link: "https://www.youtube.com/watch?v=ZhYPrAYRQ-8",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Account Management,Paid Advertising,Content Marketing])-OR(*/[Search Engine Optimization,Paid Advertising])-OR(*/[Branding,Business]-(*)-(*)"
    },
    {
      priority: 81,
      _id: "60b231987b12b9618204e7b5",
      phase: "Learning",
      level: 1,
      module: 4,
      title: "Is SEO Good Career in India? SEO Future Scope in (2021)",
      link: "https://digitalseoland.com/blog/seo-as-career/",
      type: "ARTICLE",
      img:
        "https://digitalseoland.com/wp-content/uploads/2019/06/SEO-as-Career-4-768x402.jpg",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Account Management,Paid Advertising,Content Marketing])-OR(*/[Search Engine Optimization,Paid Advertising])-OR(*/[Branding,Business]-(*)-(*)"
    },
    {
      priority: 1,
      _id: "6040ee5ccd0316041aca76aa",
      phase: "Learning",
      level: 2,
      module: 4,
      title: "On-page vs. Off page SEO",
      link: "https://www.youtube.com/watch?v=9Zp9cSyOkkY",
      type: "VIDEO",
      img: null,
      expression:
        "(*)-OR(*/Search Engine Optimization,Search Engine Marketing)-OR(*/Search Engine Optimization)-OR(*/[Branding,Business])-(*)-(*/)"
    },
    {
      priority: 2,
      _id: "60422b53334ba439684e57b4",
      phase: "Learning",
      level: 2,
      module: 4,
      title: "On-Page SEO | On-Page SEO Tutorial",
      link: "https://www.youtube.com/watch?v=o9rC7AdYkRo",
      type: "VIDEO",
      img: null,
      expression:
        "(*)-OR(*/Search Engine Optimization,Search Engine Marketing)-OR(*/Search Engine Optimization)-OR(*/[Branding,Business])-(*)-(*/)"
    },
    {
      priority: 3,
      _id: "6040ee5ccd0316041aca76ab",
      phase: "Learning",
      level: 2,
      module: 4,
      title: "Keyword Research Tutorial",
      link: "https://www.youtube.com/watch?v=OMJQPqG2Uas",
      type: "VIDEO",
      img: null,
      expression:
        "(*)-OR(*/Search Engine Optimization,Search Engine Marketing)-OR(*/Search Engine Optimization)-OR(*/[Branding,Business])-(*)-(*/)"
    },
    {
      priority: 4,
      _id: "6040ee5ccd0316041aca76ac",
      phase: "Learning",
      level: 2,
      module: 4,
      title: "How to Create an SEO Strategy for 2020 [Template Included]",
      link: "https://blog.hubspot.com/marketing/seo-strategy",
      type: "ARTICLE",
      img: "https://blog.hubspot.com/hubfs/create-seo-strategy.jpg",
      expression:
        "(*)-OR(*/Search Engine Optimization,Search Engine Marketing)-OR(*/Search Engine Optimization)-OR(*/[Branding,Business])-(*)-(*/)"
    },
    {
      priority: 75,
      _id: "6040ee5ccd0316041aca76ad",
      phase: "Learning",
      level: 3,
      module: 4,
      title: 'Simple SEO Strategy: The "Middleman" Method - YouTube',
      link: "https://www.youtube.com/watch?v=433XlvMl508",
      type: "VIDEO",
      img: "",
      expression:
        "(*)-OR(*/Search Engine Optimization,Search Engine Marketing)-OR(*/Search Engine Optimization)-OR(*/[Branding,Business])-(*)-(*/)"
    },
    {
      priority: 76,
      _id: "60c762bfb61a06112a7c309b",
      phase: "Learning",
      level: 3,
      module: 4,
      title: "HOW SEARCH ENGINES WORK: CRAWLING, INDEXING, AND RANKING",
      link: "https://moz.com/beginners-guide-to-seo/how-search-engines-operate",
      type: "ARTICLE",
      img:
        "https://moz.com/cms/_1200x630_crop_center-center_82_none/BGSEO_ch2_V3-01.png",
      expression:
        "(*)-OR(*/Search Engine Optimization,Search Engine Marketing)-OR(*/Search Engine Optimization)-OR(*/[Branding,Business])-(*)-(*/)"
    },
    {
      priority: 77,
      _id: "60b231997b12b9618204e7e1",
      phase: "Learning",
      level: 3,
      module: 4,
      title: "Off-page optimization",
      link: "https://www.youtube.com/watch?v=KsvmOSvDcqQ",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/Search Engine Optimization,Search Engine Marketing)-OR(*/Search Engine Optimization)-OR(*/[Branding,Business])-(*)-(*/)"
    },
    {
      priority: 78,
      _id: "60b231997b12b9618204e7e6",
      phase: "Learning",
      level: 3,
      module: 4,
      title: "Professional Link Building",
      link:
        "https://www.hobo-web.co.uk/link-building-strategy-for-beginners-a-month-of-free-tips/",
      type: "ARTICLE",
      img:
        "https://www.hobo-web.co.uk/wp-content/uploads/Screenshot-2018-02-24-05.41.06-compressor.png",
      expression:
        "(*)-OR(*/Search Engine Optimization,Search Engine Marketing)-OR(*/Search Engine Optimization)-OR(*/[Branding,Business])-(*)-(*/)"
    },
    {
      priority: 79,
      _id: "6040ee5ccd0316041aca76ae",
      phase: "Learning",
      level: 3,
      module: 4,
      title: "Seven Free SEO Tools You Should Be Using",
      link: "https://neilpatel.com/blog/seven-free-seo-tools/",
      type: "ARTICLE",
      img:
        "https://i.pinimg.com/originals/5b/e6/2d/5be62dbcdf69ccf40b0f28cd5919dfa8.jpg",
      expression:
        "(*)-OR(*/Search Engine Optimization,Search Engine Marketing)-OR(*/Search Engine Optimization)-OR(*/[Branding,Business])-(*)-(*/)"
    },
    {
      priority: 80,
      _id: "6040ee5ccd0316041aca76af",
      phase: "Learning",
      level: 3,
      module: 4,
      title: "Is SEO functioning - test",
      link: "https://getphound.com/how-do-i-know-if-my-seo-is-working/",
      type: "ARTICLE",
      img:
        "https://getphound.com/wp-content/uploads/2018/09/pexels-photo-1080865.jpg",
      expression:
        "(*)-OR(*/Search Engine Optimization,Search Engine Marketing)-OR(*/Search Engine Optimization)-OR(*/[Branding,Business])-(*)-(*/)"
    },
    {
      priority: 82,
      _id: "6040ee5ccd0316041aca76b0",
      phase: "Learning",
      level: 1,
      module: 5,
      title: "\n\n What does a search engine marketing specialist do?\n\n",
      link: "https://www.reliablesoft.net/seo-specialist/#salary",
      type: "ARTICLE",
      img:
        "https://www.reliablesoft.net/wp-content/uploads/2019/06/seo-specialist-salary.png",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Account Management,Paid Advertising])-OR(*/Paid Advertising)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 83,
      _id: "6040ee5ccd0316041aca76b1",
      phase: "Learning",
      level: 1,
      module: 5,
      title: "SEM Specialist Salary",
      link:
        "https://www.payscale.com/research/IN/Job=Search_Engine_Marketing_(SEM)_Specialist/Salary",
      type: "ARTICLE",
      img:
        "https://www.upgrad.com/blog/wp-content/uploads/2019/08/2DM-Image-1-1.png",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Account Management,Paid Advertising])-OR(*/Paid Advertising)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 86,
      _id: "6040ee5ccd0316041aca76b2",
      phase: "Learning",
      level: 1,
      module: 5,
      title: "Paid Ads",
      link: "https://neilpatel.com/blog/paid-internet-advertising/",
      type: "ARTICLE",
      img:
        "https://neilpatel.com/wp-content/uploads/2021/05/shutterstock_1511711003.png",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Account Management,Paid Advertising])-OR(*/Paid Advertising)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 85,
      _id: "60422b53334ba439684e57b5",
      phase: "Learning",
      level: 1,
      module: 5,
      title: "Google Ads Tutorial",
      link: "https://youtu.be/yjKOz9OO-cQ",
      type: "VIDEO",
      img: null,
      expression:
        "(*)-OR(*/[Search Engine Optimization,Account Management,Paid Advertising])-OR(*/Paid Advertising)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 83,
      _id: "60b728e2fe14f6322ad98e4f",
      phase: "Learning",
      level: 2,
      module: 5,
      title:
        "Best Practices for Setting Ad Campaign Goals and Determining Parameters for Success",
      link: "https://play.vidyard.com/9ni6rz84r7xBAH3FwLvGv9?",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Search Engine Marketing,Paid Advertising])-OR(*/Paid Advertising)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 84,
      _id: "60b728e2fe14f6322ad98e53",
      phase: "Learning",
      level: 2,
      module: 5,
      title: "Pro tips for mastering Facebook's Ads Manager",
      link: "https://play.vidyard.com/E23WRYP2d6eSLMpqJ9SQpY?",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Search Engine Marketing,Paid Advertising])-OR(*/Paid Advertising)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 85,
      _id: "60b728e2fe14f6322ad98e58",
      phase: "Learning",
      level: 2,
      module: 5,
      title: "Google Ads: Google Ads Campaign Structure",
      link: "https://play.vidyard.com/FfKystNN2VSjfW5YVKXFPW?",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Search Engine Marketing,Paid Advertising])-OR(*/Paid Advertising)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 86,
      _id: "60b728e2fe14f6322ad98e5c",
      phase: "Learning",
      level: 2,
      module: 5,
      title: "Measuring engagement & impact of ad campaigns",
      link: "https://play.vidyard.com/nHpH6ct2b9RoomgTVg9bE1?",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Search Engine Marketing,Paid Advertising])-OR(*/Paid Advertising)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 87,
      _id: "6040ee5ccd0316041aca76b3",
      phase: "Learning",
      level: 2,
      module: 5,
      title:
        "How to Build, Execute, and Optimize a PPC Strategy in 9 Steps - Alexa Blog",
      link: "https://blog.alexa.com/ppc-strategies/",
      type: "ARTICLE",
      img: "https://blog.alexa.com/wp-content/uploads/2019/02/2-Paid-SERP.png",
      expression:
        "(*)-OR(*/[Search Engine Marketing,Paid Advertising])-OR(*/Paid Advertising)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 88,
      _id: "6040ee5ccd0316041aca76b4",
      phase: "Learning",
      level: 2,
      module: 5,
      title: "Google Ads Tutorial | Google Ads Campaign Setup 2020",
      link: "https://www.youtube.com/watch?v=nLH8sIM6xVE",
      type: "VIDEO",
      img: "https://img.youtube.com/vi/F78qCf-DvHc/default.jpg",
      expression:
        "(*)-OR(*/[Search Engine Marketing,Paid Advertising])-OR(*/Paid Advertising)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 89,
      _id: "6040ee5ccd0316041aca76b5",
      phase: "Learning",
      level: 2,
      module: 5,
      title: "GoogleAds Strategies",
      link: "https://www.youtube.com/watch?v=jF6gbkJ0hHQ",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Search Engine Marketing,Paid Advertising])-OR(*/Paid Advertising)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 92,
      _id: "6040ee5ccd0316041aca76b6",
      phase: "Learning",
      level: 3,
      module: 5,
      title:
        "The Beginnerâ€™s Guide to Tracking and Analyzing Google Ads Metrics | Act-On",
      link:
        "https://act-on.com/blog/tracking-and-analyzing-google-ads-campaign-metrics/",
      type: "ARTICLE",
      img:
        "https://act-on.com/wp-content/uploads/2020/06/logo_actOn_leaves_136x142_padded.png",
      expression:
        "(*)-OR(*/[Search Engine Marketing,Paid Advertising])-(*)-OR(*/[Business,Job])-(*)-(*)"
    },
    {
      priority: 94,
      _id: "6040ee5ccd0316041aca76b7",
      phase: "Learning",
      level: 3,
      module: 5,
      title:
        "Improve Google Ads Click-Through Rate Today - 8 Advanced Ways to Increase Google AdWords CTR",
      link: "https://www.youtube.com/watch?v=v1UOpPtofiA",
      type: "VIDEO",
      img: "https://img.youtube.com/vi/v1UOpPtofiA/default.jpg",
      expression:
        "(*)-OR(*/[Search Engine Marketing,Paid Advertising])-(*)-OR(*/[Business,Job])-(*)-(*)"
    },
    {
      priority: 95,
      _id: "6040ee5ccd0316041aca76b8",
      phase: "Learning",
      level: 3,
      module: 5,
      title: "How To Use Negative Keywords In Google Ads - Part 1 Advanced",
      link: "https://www.youtube.com/watch?v=OpOIVaBm5UQ",
      type: "VIDEO",
      img: "https://img.youtube.com/vi/OpOIVaBm5UQ/default.jpg",
      expression:
        "(*)-OR(*/[Search Engine Marketing,Paid Advertising])-(*)-OR(*/[Business,Job])-(*)-(*)"
    },
    {
      priority: 96,
      _id: "6040ee5ccd0316041aca76b9",
      phase: "Learning",
      level: 3,
      module: 5,
      title: "The Ultimate Google Ads Optimization Routine - 25 Rules To Follow",
      link: "https://klientboost.com/ppc/adwords-optimization/",
      type: "ARTICLE",
      img:
        "https://3jbq2ynuxa-flywheel.netdna-ssl.com/wp-content/uploads/2017/01/Screen-Shot-2017-01-24-at-9.37.45-AM.png",
      expression:
        "(*)-OR(*/[Search Engine Marketing,Paid Advertising])-(*)-OR(*/[Business,Job])-(*)-(*)"
    },
    {
      priority: 93,
      _id: "60422b53334ba439684e57b6",
      phase: "Learning",
      level: 3,
      module: 5,
      title: "Guide to Google Adwords PPC",
      link: "https://blog.hubspot.com/marketing/google-adwords-ppc",
      type: "ARTICLE",
      img:
        "https://blog.hubspot.com/hs-fs/hubfs/carousel-4-1.jpg?width=445&name=carousel-4-1.jpg",
      expression:
        "(*)-OR(*/[Search Engine Marketing,Paid Advertising])-(*)-OR(*/[Business,Job])-(*)-(*)"
    },
    {
      priority: 99,
      _id: "6040ee5ccd0316041aca76bb",
      phase: "Learning",
      level: 1,
      module: 7,
      title: "5 Skills to Master Digtal Marketing",
      link: "https://youtu.be/8i1tfrEx9R0",
      type: "VIDEO",
      img: null,
      expression:
        "(*)-OR(*/Account Management)-OR(*/Account Management)-OR(*/Freelancing)-OR(*/Agency)-(*)"
    },
    {
      priority: 101,
      _id: "6040ee5ccd0316041aca76bd",
      phase: "Learning",
      level: 1,
      module: 7,
      title: "Average Client Service Executive Salary in India",
      link:
        "https://www.payscale.com/research/IN/Job=Client_Service_Executive/Salary",
      type: "ARTICLE",
      img:
        "https://www.saleshacker.com/wp-content/uploads/2019/05/Screen-Shot-2019-06-26-at-10.14.34-AM-1024x381.png",
      expression:
        "(*)-OR(*/Account Management)-OR(*/Account Management)-OR(*/Freelancing)-OR(*/Agency)-(*)"
    },
    {
      priority: 107,
      _id: "60433b6504b22d50bfe80b08",
      phase: "Learning",
      level: 2,
      module: 7,
      title:
        "The Top 10 Client Questions Digital Agencies Should Know How to Answer",
      link:
        "https://instapage.com/blog/answering-client-questions-from-agency-perspective",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSUhBsxw4Aqvc2MbORaL-ffLzUATptblO9SxA&usqp=CAU",
      expression:
        "(*)-OR(*/Account Management)-OR(*/Account Management)-OR(*/Freelancing)-OR(*/Agency)-(*)"
    },
    {
      priority: 103,
      _id: "6040ee5ccd0316041aca76be",
      phase: "Learning",
      level: 1,
      module: 7,
      title: "A Day in the Life of an Account Manager",
      link: "https://www.youtube.com/watch?v=FTq3nkQN3jk",
      type: "VIDEO",
      img: "https://img.youtube.com/vi/VIIEfKbA1MU/default.jpg",
      expression:
        "(*)-OR(*/Account Management)-OR(*/Account Management)-(*)-(*)-(*)"
    },
    {
      priority: 104,
      _id: "6040ee5ccd0316041aca76bf",
      phase: "Learning",
      level: 1,
      module: 7,
      title:
        "Guide to Bookkeeping for Freelancers Part 1 - Double Your Freelancing",
      link: "https://blog.appsumo.com/bookkeeping-101/",
      type: "ARTICLE",
      img:
        "https://blog.appsumo.com/wp-content/uploads/2020/06/AS-BLOG-Bookkeeping-1536x614px.jpg",
      expression:
        "(*)-OR(*/Account Management)-OR(*/Account Management)-OR(*/[Freelancing,Branding])-(*)-(*)"
    },
    {
      priority: 110,
      _id: "60433b6504b22d50bfe80b09",
      phase: "Learning",
      level: 2,
      module: 7,
      title: "8 Time Management Skills Every Freelancer Must Master",
      link:
        "https://www.format.com/magazine/resources/art/time-management-skills",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfUVZb2j4gkM1WgefWmYdh0UpsNL66dEq4sg&usqp=CAU",
      expression:
        "(*)-OR(*/Account Management)-OR(*/Account Management)-OR(*/[Freelancing,Branding])-(*)-(*)"
    },
    {
      priority: 105,
      _id: "60433b6504b22d50bfe80b07",
      phase: "Learning",
      level: 1,
      module: 7,
      title: "Secrets To Successful Digital Account Management | MRS Blog",
      link:
        "https://mrs.digital/blog/secrets-to-successful-account-management/#:~:text=Secrets%20To%20Successful%20Account%20ManagementYou%20need%20a%20lot%20of,Keep%20everyone%20happy.",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSFkjVp7TNZBjVn43bRjpIZwCvvIFDY__ku1A&usqp=CAU",
      expression:
        "(*)-OR(*/Account Management)-OR(*/Account Management)-OR(*/[Freelancing,Branding])-OR(*/Agency)-(*)"
    },
    {
      priority: 108,
      _id: "6040ee5ccd0316041aca76c0",
      phase: "Learning",
      level: 2,
      module: 7,
      title: "5 Tips for Better Client Briefs",
      link: "https://youtu.be/j0JSYckHlS8",
      type: "VIDEO",
      img: "https://img.youtube.com/vi/j0JSYckHlS8/default.jpg",
      expression:
        "(*)-OR(*/Account Management)-OR(*/Account Management)-OR(*/[Freelancing,Branding])-OR(*/Agency)-(*)"
    },
    {
      priority: 109,
      _id: "6040ee5ccd0316041aca76c1",
      phase: "Learning",
      level: 2,
      module: 7,
      title: "Client Management - How To Manage Your Clients",
      link: "https://www.youtube.com/watch?v=CElZqUUQc4k&t=1s",
      type: "VIDEO",
      img: "https://img.youtube.com/vi/CElZqUUQc4k/default.jpg",
      expression:
        "(*)-OR(*/Account Management)-OR(*/Account Management)-OR(*/[Freelancing,Branding])-OR(*/Agency)-(*)"
    },
    {
      priority: 102,
      _id: "60422b53334ba439684e57b7",
      phase: "Learning",
      level: 1,
      module: 7,
      title: "Role of Account Manager in a Digital Marketing Agency",
      link: "https://www.youtube.com/watch?v=twldJl-MGjE",
      type: "VIDEO",
      img:
        "https://www.equinetacademy.com/wp-content/uploads/Mid-sized-Digital-Marketing-Team-Structure-600x499.png",
      expression:
        "(*)-OR(*/Account Management)-OR(*/Account Management)-(*)-OR(*/Agency)-(*)"
    },
    {
      priority: 98,
      _id: "6040ee5ccd0316041aca76ba",
      phase: "Learning",
      level: 1,
      module: 7,
      title: "Art of Client Servicing",
      link:
        "https://www.franco.com/core-values-and-connections-from-the-art-of-client-service/#:~:text=Franco's%20ability%20to%20form%20meaningful,without%20action%20are%20just%20words.",
      type: "ARTICLE",
      img:
        "https://www.franco.com//wp-content/uploads/2018/06/trust-triangle.jpg",
      expression:
        "(*)-OR(*/Account Management)-OR(*/Account Management)-OR(*/[Freelancing,Branding,Business])-OR(*/Agency)-(*)"
    },
    {
      priority: 100,
      _id: "6040ee5ccd0316041aca76bc",
      phase: "Learning",
      level: 1,
      module: 7,
      title: "Account Management vs. Sales: What's the Difference? [FAQ]",
      link:
        "https://blog.hubspot.com/sales/account-management-vs-sales#:~:text=Account%20managers%20are%20in%20charge,rep%20has%20closed%20the%20business.&text=While%20the%20client's%20questions%20and,from%20and%20to%20the%20client.",
      type: "ARTICLE",
      img:
        "https://blog.hubspot.com/hubfs/Sales_Blog/account-management-vs-sales.jpg",
      expression:
        "(*)-OR(*/Account Management)-OR(*/Account Management)-OR(*/[Freelancing,Branding,Business])-OR(*/Agency)-(*)"
    },
    {
      priority: 112,
      _id: "6040ee5ccd0316041aca76c2",
      phase: "Learning",
      level: 3,
      module: 7,
      title: "Mistakes in Reporting",
      link:
        "https://www.visiture.com/blog/biggest-mistakes-reporting-digital-marketing-clients/",
      type: "ARTICLE",
      img:
        "https://1o56jg2d84kn2gttsn20ravj-wpengine.netdna-ssl.com/wp-content/uploads/2018/12/Biggest-Mistakes-in-Reporting-Digital-Marketing-to-Clients.jpg",
      expression:
        "(*)-OR(*/Account Management)-OR(*/Account Management)-OR(*/Freelancing)-(*)-(*)"
    },
    {
      priority: 113,
      _id: "6040ee5ccd0316041aca76c3",
      phase: "Learning",
      level: 3,
      module: 7,
      title: "Project Management - How to Manage Your Clients",
      link: "https://www.youtube.com/watch?v=wEvVoXZzkKU&t=2s",
      type: "VIDEO",
      img: "https://img.youtube.com/vi/wEvVoXZzkKU/default.jpg",
      expression:
        "(*)-OR(*/Account Management)-OR(*/Account Management)-OR(*/Freelancing)-(*)-(*)"
    },
    {
      priority: 114,
      _id: "6040ee5ccd0316041aca76c4",
      phase: "Learning",
      level: 3,
      module: 7,
      title: "Mastering the world of Account Management",
      link:
        "https://powerdigitalmarketing.com/blog/mastering-the-world-of-account-management/#gref",
      type: "ARTICLE",
      img:
        "https://powerdigitalmarketing.com/wp-content/uploads/2020/05/accountmanagement.jpg",
      expression:
        "(*)-OR(*/Account Management)-OR(*/Account Management)-OR(*/Freelancing)-(*)-(*)"
    },
    {
      priority: 115,
      _id: "6040ee5ccd0316041aca76c5",
      phase: "Learning",
      level: 3,
      module: 7,
      title: "Navigating Difficult Client Conversations",
      link:
        "https://sharpspring.com/blog/agency-tips-navigating-difficult-client-conversations/",
      type: "ARTICLE",
      img:
        "https://wp.static-cdn-shsp.com/wp-content/uploads/2021/03/shutterstock_1041332596-scaled.jpg",
      expression:
        "(*)-OR(*/Account Management)-OR(*/Account Management)-OR(*/Freelancing)-(*)-(*)"
    },
    {
      priority: 116,
      _id: "60433b6504b22d50bfe80b0a",
      phase: "Learning",
      level: 3,
      module: 7,
      title: "Crisis Management",
      link: "https://www.reputationmanagement.com/blog/crisis-management/",
      type: "ARTICLE",
      img:
        "https://www.reputationmanagement.com/wp-content/uploads/2018/06/crisis-management.jpg",
      expression:
        "(*)-OR(*/Account Management)-OR(*/Account Management)-OR(*/Freelancing)-(*)-(*)"
    },
    {
      priority: 123,
      _id: "6040ee5ccd0316041aca76c9",
      phase: "Learning",
      level: 1,
      module: 6,
      title: "How to get High Earning Email Marketing Jobs in India",
      link: "https://www.digitalvidya.com/blog/email-marketing-jobs/",
      type: "ARTICLE",
      img:
        "https://www.digitalvidya.com/wp-content/uploads/2017/09/Email-Marketing-Jobs-4_a0cc8df907f2dc11c3220be17344dbdc-1280x720.jpg",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing,Paid Advertising])-OR(*/Paid Advertising)-OR(*/[Job,Promotion,Branding])-(*)-(*)"
    },
    {
      priority: 121,
      _id: "60422b53334ba439684e57b8",
      phase: "Learning",
      level: 1,
      module: 6,
      title: "Essentials of a high converting landing page",
      link: "https://www.crazyegg.com/blog/landing-page-from-scratch/",
      type: "ARTICLE",
      img:
        "https://ceblog.s3.amazonaws.com/wp-content/uploads/2018/03/23122629/landing-page-essentials-5.jpg",
      expression:
        "(*)-(*/[Search Engine Optimization,Content Marketing,Paid Advertising])-(*/Paid Advertising)-(*/[Business,Freelancing])-(*)-(*)"
    },
    {
      priority: 118,
      _id: "6040ee5ccd0316041aca76c6",
      phase: "Learning",
      level: 1,
      module: 6,
      title: "Getting started with E-mail marketing",
      link: "https://www.youtube.com/watch?v=1kmR7-PEtQk",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing,Paid Advertising])-OR(*/[Paid Advertising,Content Marketing])-OR(*/[Business,Freelancing])-(*)-(*)"
    },
    {
      priority: 119,
      _id: "60433b6504b22d50bfe80b0b",
      phase: "Learning",
      level: 1,
      module: 6,
      title: "Email Marketing",
      link: "https://www.canva.com/learn/email-marketing-guide/",
      type: "ARTICLE",
      img:
        "https://static-cse.canva.com/blob/135149/email-marketing-featured-image-2.620341d6.jpg",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing,Paid Advertising])-OR(*/[Paid Advertising,Content Marketing])-OR(*/[Business,Freelancing])-(*)-(*)"
    },
    {
      priority: 120,
      _id: "6040ee5ccd0316041aca76c7",
      phase: "Learning",
      level: 1,
      module: 6,
      title: "13 Types of Emails You Need to Be Sending Your Email List",
      link:
        "https://optinmonster.com/13-types-of-emails-you-need-to-be-sending-your-email-list/",
      type: "ARTICLE",
      img:
        "https://cdn.optinmonster.com/wp-content/uploads/2016/09/Welcome-to-the-MacPaw-Newsletter-e1474351183303.png",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing,Paid Advertising])-OR(*/[Paid Advertising,Content Marketing])-OR(*/[Business,Freelancing])-(*)-(*)"
    },
    {
      priority: 122,
      _id: "6040ee5ccd0316041aca76c8",
      phase: "Learning",
      level: 1,
      module: 6,
      title: "25 Emails That Target Each Stage of the Customer Lifecycle",
      link:
        "https://www.activecampaign.com/blog/emails-for-stages-of-the-customer-lifecycle",
      type: "ARTICLE",
      img:
        "https://d226aj4ao1t61q.cloudfront.net/68g6hvw4e_image2019-03-06at2.46.59pm.png",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing,Paid Advertising])-OR(*/[Paid Advertising,Content Marketing])-OR(*/[Business,Freelancing])-(*)-(*)"
    },
    {
      priority: 1,
      _id: "6040ee5ccd0316041aca76ca",
      phase: "Learning",
      level: 2,
      module: 6,
      title: "Email Marketing Tips",
      link: "https://www.youtube.com/watch?v=PTsesUo3Jbg",
      type: "VIDEO",
      img: null,
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing])-(*)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 2,
      _id: "60422b53334ba439684e57b9",
      phase: "Learning",
      level: 2,
      module: 6,
      title: "Email Marketing Strategy",
      link: "https://emailmonks.com/email-marketing-strategy/#set-1",
      type: "ARTICLE",
      img:
        "https://email.uplers.com/infographics/email-marketing-campaign-tips/images/emailmonks-custom-page.jpg",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing])-(*)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 3,
      _id: "6040ee5ccd0316041aca76cb",
      phase: "Learning",
      level: 2,
      module: 6,
      title: "Spam Email",
      link: "https://mailchimp.com/resources/avoid-spam-filters/",
      type: "ARTICLE",
      img: "https://aleson-itc.com/wp-content/uploads/2019/02/MailChimp-1.jpg",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing])-(*)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 4,
      _id: "60422b53334ba439684e57ba",
      phase: "Learning",
      level: 2,
      module: 6,
      title: "Beginner's guide to Lead Generation",
      link:
        "https://blog.hubspot.com/marketing/beginner-inbound-lead-generation-guide-ht",
      type: "ARTICLE",
      img:
        "https://blog.hubspot.com/hs-fs/hubfs/larger-inbound-methodology.png?width=600&name=larger-inbound-methodology.png",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing])-(*)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 5,
      _id: "6040ee5ccd0316041aca76cc",
      phase: "Learning",
      level: 2,
      module: 6,
      title: "Converting Visitors to Leads",
      link: "https://www.youtube.com/watch?v=DgfmNF2yVS8",
      type: "VIDEO",
      img: null,
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing])-(*)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 131,
      _id: "6040ee5ccd0316041aca76cd",
      phase: "Learning",
      level: 3,
      module: 6,
      title: "Getting Started with Automated Email Marketing",
      link:
        "https://www.wordstream.com/blog/ws/2020/09/01/automated-email-marketing",
      type: "ARTICLE",
      img:
        "https://contentmarketinginstitute.com/wp-content/uploads/2018/11/email-marketing-today-600x290.png",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing])-(*)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 132,
      _id: "6040ee5ccd0316041aca76ce",
      phase: "Learning",
      level: 3,
      module: 6,
      title:
        "10 Free Email Marketing Tools to Save Time and Money | Sprout Social",
      link: "https://sproutsocial.com/insights/free-email-marketing-tools/",
      type: "ARTICLE",
      img:
        "https://media.sproutsocial.com/uploads/2019/06/free-email-marketing-tools.jpg",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing])-(*)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 133,
      _id: "6040ee5ccd0316041aca76cf",
      phase: "Learning",
      level: 3,
      module: 6,
      title: "Landing Page Optimization: Best Practices, Tips, Tools",
      link: "https://www.crazyegg.com/blog/landing-page-optimization/",
      type: "ARTICLE",
      img:
        "https://i.pinimg.com/originals/2a/db/ce/2adbce2e0974a63d0aea0f56a78ae98f.png",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing])-(*)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 134,
      _id: "60422b53334ba439684e57bb",
      phase: "Learning",
      level: 3,
      module: 6,
      title: "Top Lead Generation Tools",
      link: "https://www.leadfeeder.com/blog/top-lead-generation-tools/",
      type: "ARTICLE",
      img:
        "https://images.ctfassets.net/plii0v5gbc4s/3mYKPTgIoaSP7YFnqxtT5o/74b121dee11034cf809ab6be8b93496a/top-lead-generation-tools-leadfeeder.png",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing])-(*)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 135,
      _id: "60422b53334ba439684e57bc",
      phase: "Learning",
      level: 3,
      module: 6,
      title: "Ultimate Guide to E-mail Marketing",
      link:
        "https://www.singlegrain.com/email-marketing/the-ultimate-guide-to-drip-campaigns/",
      type: "ARTICLE",
      img:
        "https://www.singlegrain.com/wp-content/uploads/2017/01/The-Ultimate-Guide-to-Drip-Campaigns1.png",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing])-(*)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 136,
      _id: "6040ee5ccd0316041aca76d0",
      phase: "Learning",
      level: 1,
      module: 8,
      title: "Introdution to Web Analytics",
      link: "https://themeisle.com/blog/what-is-web-analytics/",
      type: "ARTICLE",
      img:
        "https://s15165.pcdn.co/wp-content/uploads/2018/12/web-analytics-e1550654262443.png",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing,Account Management,Paid Advertising])-OR(*/Search Engine Optimization)-(*)-(*)-(*)"
    },
    {
      priority: 138,
      _id: "6040ee5ccd0316041aca76d2",
      phase: "Learning",
      level: 1,
      module: 8,
      title: "Beginner's Guide for Google Analytics",
      link:
        "https://www.monsterinsights.com/how-does-google-analytics-work-beginners-guide/",
      type: "ARTICLE",
      img:
        "https://www.monsterinsights.com/wp-content/uploads/2018/08/how-does-ga-work.jpg",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing,Account Management,Paid Advertising])-OR(*/Search Engine Optimization)-(*)-(*)-(*)"
    },
    {
      priority: 140,
      _id: "60422b53334ba439684e57bd",
      phase: "Learning",
      level: 1,
      module: 8,
      title: "Creating Customer Reports",
      link: "https://www.youtube.com/watch?v=DVw9ZZImXbI",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing,Account Management,Paid Advertising])-OR(*/Search Engine Optimization)-(*)-(*)-(*)"
    },
    {
      priority: 142,
      _id: "60422b53334ba439684e57bf",
      phase: "Learning",
      level: 1,
      module: 8,
      title: "Guide to Google Analytics for WordPress",
      link: "https://firstsiteguide.com/google-analytics-for-wordpress/",
      type: "ARTICLE",
      img:
        "https://firstsiteguide.com/wp-content/uploads/2018/05/The-beginners-guide-to-google-analytics-for-WordPress.png",
      expression:
        "(*)-OR(*/[Search Engine Optimization,Content Marketing,Account Management,Paid Advertising])-OR(*/Search Engine Optimization)-(*)-(*)-(*)"
    },
    {
      priority: 144,
      _id: "6040ee5ccd0316041aca76d4",
      phase: "Learning",
      level: 1,
      module: 9,
      title: "Introduction to Mobile Marketing",
      link:
        "https://www.wordstream.com/blog/ws/2013/08/19/what-is-mobile-marketing",
      type: "ARTICLE",
      img:
        "https://wordstream-files-prod.s3.amazonaws.com/s3fs-public/styles/simple_image/public/images/marketing-for-mobile.jpg",
      expression: "(*)-OR(*/[Social Media,Content Marketing])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 145,
      _id: "6040ee5ccd0316041aca76d5",
      phase: "Learning",
      level: 1,
      module: 9,
      title: "What is Mobile Marketing",
      link: "https://www.marketo.com/mobile-marketing/",
      type: "ARTICLE",
      img:
        "https://t3y4b2m7.rocketcdn.me/wp-content/uploads/2018/02/Adobe-Mobile.png",
      expression: "(*)-OR(*/[Social Media,Content Marketing])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 147,
      _id: "60433b6504b22d50bfe80b0d",
      phase: "Learning",
      level: 1,
      module: 9,
      title:
        "17 Mobile App Marketing Tools You Need to Know Right Now - Shane Barker",
      link: "https://shanebarker.com/blog/mobile-app-marketing-tools/",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQjhQExchiW717u-OGJvnHXxKP7ffnUtSCnbg&usqp=CAU",
      expression: "(*)-OR(*/[Social Media,Content Marketing])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 149,
      _id: "60422b53334ba439684e57c2",
      phase: "Learning",
      level: 1,
      module: 9,
      title: "Mobile Commerce",
      link:
        "https://www.bigcommerce.com/blog/mobile-commerce/#what-is-mobile-commerce",
      type: "ARTICLE",
      img:
        "https://www.bigcommerce.com/blog/wp-content/uploads/2018/09/Mobile-commerce-growth.jpg",
      expression: "(*)-OR(*/[Social Media,Content Marketing])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 150,
      _id: "60b481b307168119a3c24db2",
      phase: "Learning",
      level: 1,
      module: 9,
      title: "Mobile Marketing Strategies",
      link: "https://www.canva.com/learn/mobile-marketing-strategies/",
      type: "ARTICLE",
      img:
        "https://static-cse.canva.com/blob/123436/Social-media-marketing-on-mobile-Grow-your-business-with-these-7-mobile-content-strategies.aa6158eb.png",
      expression: "(*)-OR(*/[Social Media,Content Marketing])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 151,
      _id: "60b231967b12b9618204e7a5",
      phase: "Learning",
      level: 1,
      module: 9,
      title: "Mobile App Marketing Tools",
      link: "https://www.pinterest.nz/pin/212021095100089993/",
      type: "ARTICLE",
      img:
        "https://i.pinimg.com/236x/40/b9/66/40b9660d71bcf0cb9df32ad48c74adb9.jpg",
      expression: "(*)-OR(*/[Social Media,Content Marketing])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 146,
      _id: "60433b6504b22d50bfe80b0c",
      phase: "Learning",
      level: 1,
      module: 9,
      title: " A Step-By-Step Guide to Setting Up a Mobile Marketing Campaign",
      link:
        "https://www.convinceandconvert.com/mobile/a-step-by-step-guide-to-setting-up-a-mobile-marketing-campaign/",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSYW4i_aAeZWlTkT9Yq5gGB9nSyzj87ozsEDw&usqp=CAU",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 148,
      _id: "60422b53334ba439684e57c1",
      phase: "Learning",
      level: 1,
      module: 9,
      title: "Mobile Marketing Case Studies",
      link: "https://www.mmaglobal.com/case-study-hub/",
      type: "ARTICLE",
      img: "https://www.mmaglobal.com/case-study-hub/img/mma-phone.png",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 150,
      _id: "6040ee5ccd0316041aca76d6",
      phase: "Learning",
      level: 1,
      module: 17,
      title: "Native Advertising",
      link: "https://www.outbrain.com/native-advertising/",
      type: "ARTICLE",
      img:
        "https://www.outbrain.com/blog/wp-content/uploads/2018/07/native-advertising.jpg",
      expression: "(*)-(*/[Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 151,
      _id: "6040ee5ccd0316041aca76d7",
      phase: "Learning",
      level: 1,
      module: 17,
      title: "Beginner's Guide to Native Advertising",
      link: "https://www.rialtomarketing.com/guide-to-native-advertising/",
      type: "ARTICLE",
      img:
        "https://www.rialtomarketing.com/wp-content/uploads/2020/04/Native-advertising-a-guide-for-businesses-A-Sample-768x552.png",
      expression: "(*)-(*/[Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 152,
      _id: "60422b53334ba439684e57c3",
      phase: "Learning",
      level: 1,
      module: 17,
      title: "Examples of Native Advertising",
      link:
        "https://www.cyberclick.net/numericalblogen/5-best-examples-of-native-advertising-2020",
      type: "ARTICLE",
      img:
        "https://www.cyberclick.net/hs-fs/hubfs/04.%20BLOG/Native%20ads.jpg?width=850&name=Native%20ads.jpg",
      expression: "(*)-(*/[Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 153,
      _id: "6040ee5ccd0316041aca76d8",
      phase: "Learning",
      level: 1,
      module: 16,
      title: "What is display advertising?",
      link: "https://www.youtube.com/watch?v=4T6Ia20D-T8&t=4s",
      type: "VIDEO",
      img: "https://img.youtube.com/vi/4T6Ia20D-T8/default.jpg",
      expression: "(*)-(*/[Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 154,
      _id: "6040ee5ccd0316041aca76d9",
      phase: "Learning",
      level: 1,
      module: 16,
      title: "What Are Display Ads? The Complete Guide",
      link:
        "https://www.acquisio.com/blog/agency/what-are-display-ads-5-steps-to-effective-visual-advertising/#:~:text=Display%20advertising%20is%20a%20method,(e.g.%20make%20a%20purchase).",
      type: "ARTICLE",
      img:
        "data:image/jpeg;base64,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",
      expression: "(*)-(*/[Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 155,
      _id: "60433b6504b22d50bfe80b0e",
      phase: "Learning",
      level: 1,
      module: 16,
      title: "Types of Digital Advertising: How to Choose the Right Ad Type",
      link: "https://purevisibility.com/choosing-ad-type/",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcREmH1IYLXTwishwcq2_GL-YEanwe6qzhZGJA&usqp=CAU",
      expression: "(*)-(*/[Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 156,
      _id: "60433b6504b22d50bfe80b0f",
      phase: "Learning",
      level: 1,
      module: 16,
      title: "5 Banner Advertising Case Studies",
      link: "https://blog.creatopy.com/banner-advertising-case-studies/",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQG3V2NHcrBqM9np_ec6mdlfZi4ICwLGQXYqA&usqp=CAU",
      expression: "(*)-(*/[Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 157,
      _id: "60422f70ebbf4b3c22f3e83c",
      phase: "Learning",
      level: 1,
      module: 16,
      title: "Cheat Sheet for Google Display Ads",
      link: "https://www.wordstream.com/blog/ws/2019/05/23/google-display-ads",
      type: "ARTICLE",
      img:
        "https://wordstream-files-prod.s3.amazonaws.com/s3fs-public/styles/simple_image/public/images/media/images/google-display-ads-online-advertising-landscape-data-final.png",
      expression: "(*)-(*/[Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 158,
      _id: "60433b6504b22d50bfe80b10",
      phase: "Learning",
      level: 1,
      module: 15,
      title: "What is Media Planning? | Marketing Evolution",
      link:
        "https://www.marketingevolution.com/marketing-essentials/media-planning#:~:text=Media%20planning%20is%20the%20process,to%20maximize%20engagements%20and%20ROI.&text=An%20effective%20media%20plan%20will,with%20the%20organization's%20marketing%20budget.",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSyrfJSELxr6yU5Yzfa0dL8yFKuAPr4QR4hNw&usqp=CAU",
      expression:
        "(*)-OR(*/[Social Media,Search Engine Optimization,Account Management,Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 160,
      _id: "60433b6504b22d50bfe80b12",
      phase: "Learning",
      level: 1,
      module: 15,
      title:
        "The Ultimate Guide to Marketing Strategies & How to Improve Your Digital Presence",
      link: "https://blog.hubspot.com/marketing/digital-strategy-guide",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSeaoxrspH5DYCcnaykoZm5cMkUFokJV_BtPw&usqp=CAU",
      expression:
        "(*)-OR(*/[Social Media,Search Engine Optimization,Account Management,Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 162,
      _id: "6040ee5ccd0316041aca76da",
      phase: "Learning",
      level: 1,
      module: 15,
      title: "How to be a Media Buyer",
      link: "https://www.youtube.com/watch?v=MxzadA2-4Wc",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Search Engine Optimization,Account Management,Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 164,
      _id: "6040ee5ccd0316041aca76dc",
      phase: "Learning",
      level: 1,
      module: 15,
      title: "Top 5 Marketing Campaigns",
      link:
        "https://www.talkwalker.com/blog/the-top-5-marketing-campaigns-in-india",
      type: "ARTICLE",
      img: "https://www.talkwalker.com/images/free-toolkit/blog-header-in.png",
      expression:
        "(*)-OR(*/[Social Media,Search Engine Optimization,Account Management,Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 168,
      _id: "6040ee5ccd0316041aca76de",
      phase: "Learning",
      level: 1,
      module: 14,
      title: "How to Leverage Influencer Marketing to EXPLODE Your Business",
      link: "https://www.youtube.com/watch?v=DhOrRQmQ-Z8&t=16s",
      type: "VIDEO",
      img: "https://img.youtube.com/vi/DhOrRQmQ-Z8/default.jpg",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing])-OR(*/Social Media)-OR(*/Branding)-(*)-(*)"
    },
    {
      priority: 169,
      _id: "6040ee5ccd0316041aca76df",
      phase: "Learning",
      level: 1,
      module: 14,
      title: "Using Influencer Marketing to Grow your Business",
      link: "https://www.youtube.com/watch?v=popowMuKyjY",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing])-OR(*/Social Media)-OR(*/Branding)-(*)-(*)"
    },
    {
      priority: 170,
      _id: "60433b6504b22d50bfe80b14",
      phase: "Learning",
      level: 1,
      module: 14,
      title: "The Best Influencer Marketing Case Studies From Top Brands",
      link:
        "https://mediakix.com/blog/influencer-marketing-case-studies-top-brands-campaigns-influencers/",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTF_Y7Kz70oS60ch171i6GHz1dBd150b0isog&usqp=CAU",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing])-OR(*/Social Media)-OR(*/Branding)-(*)-(*)"
    },
    {
      priority: 167,
      _id: "60422b53334ba439684e57c4",
      phase: "Learning",
      level: 1,
      module: 14,
      title: "What is Influencer Marketing",
      link: "https://www.youtube.com/watch?v=7Yt_6OLxsH8&t=76s",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing])-OR(*/Social Media)-OR(*/Branding)-(*)-(*)"
    },
    {
      priority: 172,
      _id: "6040ee5ccd0316041aca76e0",
      phase: "Learning",
      level: 1,
      module: 13,
      title: "Online Marketing - E commerce",
      link: "https://www.youtube.com/watch?v=w-KxDWTwt68",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Search Engine Optimization])-(*)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 173,
      _id: "6040ee5ccd0316041aca76e1",
      phase: "Learning",
      level: 1,
      module: 13,
      title: "Ecommerce Tips",
      link: "https://www.youtube.com/watch?v=3DdJ1JynG8M",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Search Engine Optimization])-(*)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 174,
      _id: "6040ee5ccd0316041aca76e2",
      phase: "Learning",
      level: 1,
      module: 13,
      title: "What is Affiliate Marketing And How Can You Leverage It",
      link: "https://www.youtube.com/watch?v=4ZrSmfo16sk&t=5s",
      type: "VIDEO",
      img: "https://img.youtube.com/vi/4ZrSmfo16sk/default.jpg",
      expression:
        "(*)-OR(*/[Social Media,Search Engine Optimization])-(*)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 175,
      _id: "6040ee5ccd0316041aca76e3",
      phase: "Learning",
      level: 1,
      module: 13,
      title: "6 Awesome Affiliate Marketing Strategies to Generate More Sales",
      link: "https://shanebarker.com/blog/affiliate-marketing-strategies/",
      type: "ARTICLE",
      img:
        "https://cdn.shortpixel.ai/client/q_lossy,ret_img,w_1061,h_309/https://shanebarker.com/wp-content/uploads/2018/09/SimilarWeb-Affiliate-Marketing-Strategies.png",
      expression:
        "(*)-OR(*/[Social Media,Search Engine Optimization])-(*)-OR(*/Business)-(*)-(*)"
    },
    {
      priority: 176,
      _id: "60433b6504b22d50bfe80b15",
      phase: "Learning",
      level: 1,
      module: 12,
      title: "What is Remarketing and How Does it Work?",
      link:
        "https://www.cyberclick.net/numericalblogen/what-is-remarketing-and-how-does-it-work",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQmX6IzZa8cz_4_u5jiDyc0IccbI9rTdAXjzQ&usqp=CAU",
      expression: "(*)-OR(*/[Social Media,Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 178,
      _id: "6040ee5ccd0316041aca76e4",
      phase: "Learning",
      level: 1,
      module: 12,
      title: "GoogleAds Remarketing",
      link: "https://www.youtube.com/watch?v=u6-BebzWGmw&t=38s",
      type: "VIDEO",
      img: "undefined",
      expression: "(*)-OR(*/[Social Media,Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 180,
      _id: "60433b6504b22d50bfe80b16",
      phase: "Learning",
      level: 1,
      module: 12,
      title:
        "Facebook Retargeting Ads: A Step-by-Step Guide To Facebook Retargeting",
      link: "https://www.abetterlemonadestand.com/facebook-retargeting-ads/",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnrzooh-fblNtrIgAbTtk3Q8kfQ44Vi3IIKQ&usqp=CAU",
      expression: "(*)-OR(*/[Social Media,Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 181,
      _id: "6040ee5ccd0316041aca76e5",
      phase: "Learning",
      level: 1,
      module: 12,
      title: "The 11 Best Growth Hacking Strategies to Skyrocket Your User Base",
      link: "https://optinmonster.com/growth-hacking-strategies/",
      type: "ARTICLE",
      img:
        "https://cdn.optinmonster.com/wp-content/uploads/2018/02/best-growth-hacks-use-coschedule-analyzer.jpg",
      expression: "(*)-OR(*/[Social Media,Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 184,
      _id: "6040ee5ccd0316041aca76e6",
      phase: "Learning",
      level: 1,
      module: 12,
      title: "Viral Referral Strategies",
      link: "https://www.referralcandy.com/blog/paypal-referrals/",
      type: "ARTICLE",
      img:
        "https://www.referralcandy.com/wp-content/uploads/2014/01/paypal-referrals.png",
      expression: "(*)-OR(*/[Social Media,Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 177,
      _id: "60422b53334ba439684e57c5",
      phase: "Learning",
      level: 1,
      module: 12,
      title: "What is Remarketing",
      link: "https://neilpatel.com/what-is-remarketing/",
      type: "ARTICLE",
      img: "https://neilpatel.com/wp-content/uploads/2015/11/image007.png",
      expression: "(*)-OR(*/[Social Media,Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 179,
      _id: "60422b53334ba439684e57c6",
      phase: "Learning",
      level: 1,
      module: 12,
      title: "Remarketing Strategies",
      link: "https://adespresso.com/blog/google-ads-remarketing-strategies/",
      type: "ARTICLE",
      img:
        "https://adespresso.com/wp-content/uploads/2020/05/how-to-advertise-on-google-update-1024x535.jpg",
      expression: "(*)-OR(*/[Social Media,Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 182,
      _id: "60422b53334ba439684e57c7",
      phase: "Learning",
      level: 1,
      module: 12,
      title: "Creating Viral Content",
      link:
        "https://neilpatel.com/blog/how-to-create-viral-content-that-will-drive-2500-visitors-per-day/",
      type: "ARTICLE",
      img: "https://neilpatel.com/wp-content/uploads/2015/10/viral.jpg",
      expression: "(*)-OR(*/[Social Media,Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 183,
      _id: "60422b53334ba439684e57c8",
      phase: "Learning",
      level: 1,
      module: 12,
      title: "Referral Marketing",
      link: "https://sharesomefriends.com/blog/referral-marketing/",
      type: "ARTICLE",
      img:
        "https://sharesomefriends.com/wp-content/uploads/2018/02/Untitled-Design-4-1024x512.png",
      expression: "(*)-OR(*/[Social Media,Paid Advertising])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 186,
      _id: "60433b6504b22d50bfe80b17",
      phase: "Learning",
      level: 1,
      module: 11,
      title: "Building a Community for Business",
      link: "https://www.canva.com/learn/building-community-and-business/",
      type: "ARTICLE",
      img:
        "https://static-cse.canva.com/blob/152533/tim-mossholder-epBIrtdg2Hk-unsplash-1.0aeed416.jpg",
      expression:
        "(*)-(*/[Social Media,Content Marketing,Account Management])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 188,
      _id: "6040ee5ccd0316041aca76e7",
      phase: "Learning",
      level: 1,
      module: 11,
      title: "What is Reputation Management",
      link: "https://www.youtube.com/watch?v=rtWs2CJ6H90",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-(*/[Social Media,Content Marketing,Account Management])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 189,
      _id: "60433b6504b22d50bfe80b18",
      phase: "Learning",
      level: 1,
      module: 11,
      title:
        "Online Reputation Management: A Guide for Social Media Marketers : Social Media Examiner",
      link:
        "https://www.socialmediaexaminer.com/online-reputation-management-guide-for-social-media-marketers/",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR408STmOesmgK2elrJJOr_hxYa-7nfiEEPHg&usqp=CAU",
      expression:
        "(*)-(*/[Social Media,Content Marketing,Account Management])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 190,
      _id: "6040ee5ccd0316041aca76e8",
      phase: "Learning",
      level: 1,
      module: 11,
      title: "CRM to Increase Revenues - Case Studies",
      link:
        "https://mail.bloominari.com/blog/case-study-how-b2b-companies-use-crm-to-increase-revenue",
      type: "ARTICLE",
      img:
        "https://mail.bloominari.com/media/k2/items/cache/49d777cdd477e76dea7b279017b034de_M.jpg",
      expression:
        "(*)-(*/[Social Media,Content Marketing,Account Management])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 191,
      _id: "6040ee5ccd0316041aca76e9",
      phase: "Learning",
      level: 1,
      module: 11,
      title: "Reputation Management Case Studies",
      link:
        "https://genylabs.io/online-reputation-management-in-healthcare-some-case-studies/",
      type: "ARTICLE",
      img:
        "https://genylabs.io/wp-content/uploads/2019/02/JJ-stock-price-online-reputation.png",
      expression:
        "(*)-(*/[Social Media,Content Marketing,Account Management])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 187,
      _id: "60422b53334ba439684e57c9",
      phase: "Learning",
      level: 1,
      module: 11,
      title: "Community Management",
      link:
        "https://medium.com/strategic-content-marketing/community-management-101-everything-you-wanted-to-know-about-building-your-community-from-scratch-aafb539a55a9",
      type: "ARTICLE",
      img: "https://miro.medium.com/max/2048/0*-KA-OyEBAQijLW74.png",
      expression:
        "(*)-(*/[Social Media,Content Marketing,Account Management])-(*)-(*)-(*)-(*)"
    },
    {
      priority: 180,
      _id: "60b481b207168119a3c24dac",
      phase: "Learning",
      level: 1,
      module: 10,
      title: "Branding with Personality",
      link: "https://www.canva.com/learn/branding-with-personality/",
      type: "ARTICLE",
      img: "https://static-cse.canva.com/blob/142234/Kira-Hug.10054030.jpg",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-(*)-(*)-(*)"
    },
    {
      priority: 181,
      _id: "60b231967b12b9618204e7aa",
      phase: "Learning",
      level: 1,
      module: 10,
      title: "Digital Brand Strategy",
      link: "https://freshsparks.com/digital-brand-strategy/",
      type: "ARTICLE",
      img:
        "https://freshsparks.com/wp/wp-content/uploads/2018/08/How-To-Create-A-Digital-Brand-Strategy-For-Optimal-Growth.png",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-(*)-(*)-(*)"
    },
    {
      priority: 203,
      _id: "60b481b307168119a3c24dbc",
      phase: "Learning",
      level: 2,
      module: 10,
      title: "Free Branding Templates",
      link: "https://www.canva.com/learn/branding-templates/",
      type: "ARTICLE",
      img:
        "https://static-cse.canva.com/blob/142083/architecture-buildings-business-325185.2aba483f.jpg",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-(*)-(*)-(*)"
    },
    {
      priority: 204,
      _id: "60b481b307168119a3c24dc1",
      phase: "Learning",
      level: 2,
      module: 10,
      title: "Brand Style Guides",
      link:
        "https://www.canva.com/learn/apple-google-starbucks-inside-the-web-design-style-guides-of-10-famous-companies/",
      type: "ARTICLE",
      img:
        "https://static-cse.canva.com/blob/143425/Apple-Google-Starbucks-Inside-the-Web-Design-Style-Guides-of-10-Famous-Companies_Thumb.1207ff00.png",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-(*)-(*)-(*)"
    },
    {
      priority: 194,
      _id: "60433b6504b22d50bfe80b1a",
      phase: "Learning",
      level: 2,
      module: 10,
      title: "Design in Digital Marketing: an important combination!",
      link:
        "https://blog.hotmart.com/en/importance-of-design-in-digital-marketing/#:~:text=Design%20is%20your%20ally,Producer%20or%20Affiliate%20and%20consumer.",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRzJolKWht-bXmqHUPM-cVQHU13k4TsHKLKGg&usqp=CAU",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding])-(*)-(*)"
    },
    {
      priority: 195,
      _id: "6040ee5ccd0316041aca76ea",
      phase: "Learning",
      level: 2,
      module: 10,
      title: "Trends in Graphic Designing",
      link: "https://venngage.com/blog/graphic-design-trends/",
      type: "ARTICLE",
      img:
        "https://venngage-wordpress.s3.amazonaws.com/uploads/2020/09/Graphic_Design_Trends_2021_Blog_Header.png",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding])-(*)-(*)"
    },
    {
      priority: 196,
      _id: "60433b6504b22d50bfe80b1b",
      phase: "Learning",
      level: 2,
      module: 10,
      title:
        "A Simple Guide to Design Thinking for Marketers - Digital Agency Network",
      link:
        "https://digitalagencynetwork.com/a-simple-guide-to-design-thinking-for-marketers/",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTgsVLI2KuUsDcg5CCs7scb_A1Cc5LzYcjKhA&usqp=CAU",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding])-(*)-(*)"
    },
    {
      priority: 198,
      _id: "60434cd3c2554f52fc4c6bec",
      phase: "Learning",
      level: 2,
      module: 10,
      title:
        "The Complete Guide to Brand Building (Must-Read for Digital Marketers)",
      link:
        "https://www.singlegrain.com/blog-posts/branding/the-complete-guide-to-brand-building-must-read-for-digital-marketers/",
      type: "ARTICLE",
      img:
        "https://www.singlegrain.com/wp-content/uploads/2018/07/Page-load-speed.png",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding])-(*)-(*)"
    },
    {
      priority: 200,
      _id: "6040ee5ccd0316041aca76eb",
      phase: "Learning",
      level: 2,
      module: 10,
      title: "Brand building through Social Media",
      link:
        "https://www.canva.com/learn/introduction-brand-building-social-media/",
      type: "ARTICLE",
      img:
        "https://static-cse.canva.com/blob/152106/apple-background-connection-399161.36fe8e20.jpg",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding])-(*)-(*)"
    },
    {
      priority: 202,
      _id: "60433b6504b22d50bfe80b1d",
      phase: "Learning",
      level: 2,
      module: 10,
      title: "Design Tools",
      link:
        "https://www.exabytes.digital/blog/free-online-design-tools-digital-marketing-content",
      type: "ARTICLE",
      img:
        "https://www.exabytes.digital/wp-content/uploads/2018/09/free-online-design-tools-for-your-digital-marketing-content.jpg",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding])-(*)-(*)"
    },
    {
      priority: 182,
      _id: "60b481b607168119a3c24e1a",
      phase: "Learning",
      level: 1,
      module: 10,
      title: "Branding is personal",
      link: "https://youtu.be/Qr1bXJ-Fur4",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding,Business])-(*)-(*)"
    },
    {
      priority: 183,
      _id: "60b481b607168119a3c24e1d",
      phase: "Learning",
      level: 1,
      module: 10,
      title: "Moodboard brainstorm",
      link: "https://www.canva.com/templates/EAD9hi8nDP8-moodboard-brainstorm/",
      type: "ARTICLE",
      img:
        "https://marketplace.canva.com/EAD9hi8nDP8/2/0/800w/canva-moodboard-brainstorm-CJNEp1cOivM.jpg",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding,Business])-(*)-(*)"
    },
    {
      priority: 184,
      _id: "60b481b607168119a3c24e21",
      phase: "Learning",
      level: 1,
      module: 10,
      title: "Stand out",
      link: "https://youtu.be/5ETzJG3seoA",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding,Business])-(*)-(*)"
    },
    {
      priority: 185,
      _id: "60b481b607168119a3c24e24",
      phase: "Learning",
      level: 1,
      module: 10,
      title: "Advertisement Logo",
      link:
        "https://www.canva.com/templates/EAD65kUfHnM-black-and-orange-advertisement-logo/",
      type: "ARTICLE",
      img:
        "https://marketplace.canva.com/EAD65kUfHnM/2/0/400w/canva-black-and-orange-advertisement-logo-3I3fbItDng8.jpg",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding,Business])-(*)-(*)"
    },
    {
      priority: 186,
      _id: "60b481b607168119a3c24e29",
      phase: "Learning",
      level: 1,
      module: 10,
      title: "Promote your brand",
      link: "https://youtu.be/uhj28l2WXyY",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding,Business])-(*)-(*)"
    },
    {
      priority: 187,
      _id: "60b481b607168119a3c24e2c",
      phase: "Learning",
      level: 1,
      module: 10,
      title: "Resume Template",
      link:
        "https://www.canva.com/templates/EAD7Wt6lgQI-cream-and-brown-modern-resume/",
      type: "ARTICLE",
      img:
        "https://marketplace.canva.com/EAD7Wt6lgQI/1/0/283w/canva-cream-and-brown-modern-resume-FRK6nT9fj1w.jpg",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding,Business])-(*)-(*)"
    },
    {
      priority: 188,
      _id: "60b481b607168119a3c24e30",
      phase: "Learning",
      level: 1,
      module: 10,
      title: "Pitch yourself",
      link: "https://youtu.be/6B_7UpVM3iI",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding,Business])-(*)-(*)"
    },
    {
      priority: 189,
      _id: "60b481b607168119a3c24e33",
      phase: "Learning",
      level: 1,
      module: 10,
      title: "Designing your Business Card",
      link:
        "https://www.canva.com/templates/EAD9UXYpYs0-beige-and-brown-beauty-elegant-business-card/",
      type: "ARTICLE",
      img:
        "https://marketplace.canva.com/EAD9UXYpYs0/2/0/800w/canva-beige-and-brown-beauty-elegant-business-card-J-kRnJydTWY.jpg",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding,Business])-(*)-(*)"
    },
    {
      priority: 190,
      _id: "60b481b607168119a3c24e37",
      phase: "Learning",
      level: 1,
      module: 10,
      title: "Reach your audience",
      link: "https://youtu.be/naVXN-XbKGk",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding,Business])-(*)-(*)"
    },
    {
      priority: 191,
      _id: "60b481b607168119a3c24e3a",
      phase: "Learning",
      level: 1,
      module: 10,
      title: "Building a Media Kit",
      link:
        "https://www.canva.com/templates/EADao9Y0qbg-black-and-white-sports-media-kit/",
      type: "ARTICLE",
      img:
        "https://marketplace.canva.com/EADao9Y0qbg/1/0/283w/canva-black-and-white-sports-media-kit-ySQ1MD65Cco.jpg",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding,Business])-(*)-(*)"
    },
    {
      priority: 192,
      _id: "60b481b607168119a3c24e3e",
      phase: "Learning",
      level: 1,
      module: 10,
      title: "Start Now",
      link: "https://youtu.be/zXL6KU81CdY",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding,Business])-(*)-(*)"
    },
    {
      priority: 193,
      _id: "60433b6504b22d50bfe80b19",
      phase: "Learning",
      level: 1,
      module: 10,
      title: "What Is Branding?",
      link: "https://99designs.com/blog/logo-branding/what-is-branding/",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQo-EcsXr16bTlBlyd-5VI5D_2NexhVzAFRuQ&usqp=CAU",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding,Business])-(*)-(*)"
    },
    {
      priority: 193,
      _id: "60433b6504b22d50bfe80b19",
      phase: "Learning",
      level: 2,
      module: 10,
      title: "What Is Branding?",
      link: "https://99designs.com/blog/logo-branding/what-is-branding/",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQo-EcsXr16bTlBlyd-5VI5D_2NexhVzAFRuQ&usqp=CAU",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding,Business])-(*)-(*)"
    },
    {
      priority: 197,
      _id: "60422b53334ba439684e57ca",
      phase: "Learning",
      level: 2,
      module: 10,
      title: "Branding your Business",
      link: "https://www.lyfemarketing.com/blog/brand-your-business/",
      type: "ARTICLE",
      img: "https://www.writeraccess.com/upload/7164-o0info.png",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding,Business])-(*)-(*)"
    },
    {
      priority: 199,
      _id: "60434cd3c2554f52fc4c6bed",
      phase: "Learning",
      level: 2,
      module: 10,
      title: "How to Create a Digital Brand Strategy for Optimal Growth",
      link:
        "https://www.singlegrain.com/blog-posts/branding/the-complete-guide-to-brand-building-must-read-for-digital-marketers",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRkFJpqr5Q5UhzC5xOix0dtgGhNpuwYa4wrlA&usqp=CAU",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding,Business])-(*)-(*)"
    },
    {
      priority: 201,
      _id: "60433b6504b22d50bfe80b1c",
      phase: "Learning",
      level: 2,
      module: 10,
      title: "How to Manage Your Design Team Effectively | by Plant | UX Planet",
      link:
        "https://uxplanet.org/how-to-manage-your-design-team-effectively-b6c9ecf0c2ab",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRYlkCFhaIWn9gd7kLTMEpjN4xtnh1GrDJPeQ&usqp=CAU",
      expression:
        "(*)-OR(*/[Social Media,Content Marketing,Account Management])-OR(*/[Social Media,Content Marketing])-OR(*/[Freelancing,Branding,Business])-(*)-(*)"
    },
    {
      priority: 204,
      _id: "60433b6504b22d50bfe80b1e",
      phase: "Achieve",
      level: 1,
      module: 1,
      title: "Resume Templates",
      link:
        "https://www.canva.com/learn/10-resume-templates-to-help-you-get-your-next-job/",
      type: "ARTICLE",
      img:
        "https://static-cse.canva.com/blob/123496/10-resume-templates-to-help-you-get-your-next-job.3422fd39.jpg",
      expression: "(*)-(*)-(*)-(*^[Branding,Business])-(*)-(*)"
    },
    {
      priority: 205,
      _id: "60433b6504b22d50bfe80b1f",
      phase: "Achieve",
      level: 1,
      module: 1,
      title: "Top 7 Tips for Creating the Perfect Digital Marketing CV | DMI",
      link:
        "https://digitalmarketinginstitute.com/blog/top-7-tips-for-creating-the-perfect-digital-marketing-cv",
      type: "ARTICLE",
      img:
        "https://dmi-uploads.imgix.net/general/email-promo-shortcourses_ANIMATED.gif?blur=100&bri=70&fit=max&fm=pjpg&h=500&ixlib=php-1.1.0&px=16&q=1&sat=-100&w=700&s=1a0fcad720a8405a338260f7bec884a3",
      expression: "(*)-(*)-(*)-(*^[Branding,Business])-(*)-(*)"
    },
    {
      priority: 207,
      _id: "60433b6604b22d50bfe80b22",
      phase: "Achieve",
      level: 2,
      module: 1,
      title:
        "How to make a digital marketing portfolio, despite not having any work experience - Quora",
      link:
        "https://www.quora.com/How-do-I-make-a-digital-marketing-portfolio-despite-not-having-any-work-experience-But-I-do-have-digital-marketing-certification",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfSYIHl8TXN69lP_IySnlMq2lFTliExHfqTw&usqp=CAU",
      expression: "(*)-(*)-(*)-(*^[Branding,Business])-(*)-(*)"
    },
    {
      priority: 208,
      _id: "6040ee5ccd0316041aca76ed",
      phase: "Achieve",
      level: 2,
      module: 1,
      title: "How to Make a Powerful Marketing Portfolio â Blog",
      link: "https://partners.livechat.com/blog/marketing-portfolio/",
      type: "ARTICLE",
      img: "https://partners.livechat.com/blog/marketing-portfolio-examples.jpg",
      expression: "(*)-(*)-(*)-(*^[Branding,Business])-(*)-(*)"
    },
    {
      priority: 209,
      _id: "60422b53334ba439684e57cb",
      phase: "Achieve",
      level: 2,
      module: 1,
      title: "Making Digital Portfolios",
      link: "https://libguides.madisoncollege.edu/digitalportolio/marketing",
      type: "ARTICLE",
      img:
        "https://apps7.madisoncollege.edu/sites/apps7/files/fields/splash-hero/DigitalMarketingLeadership_1280x600-min.jpg",
      expression: "(*)-(*)-(*)-(*^[Branding,Business])-(*)-(*)"
    },
    {
      priority: 213,
      _id: "60422b53334ba439684e57cc",
      phase: "Achieve",
      level: 3,
      module: 1,
      title: "Digital Marketing with Google",
      link:
        "https://learndigital.withgoogle.com/digitalunlocked/course/digital-marketing",
      type: "ARTICLE",
      img:
        "https://edmondchan.co.uk/wp-content/uploads/2020/05/Screenshot-2020-05-27-at-18.39.40.png",
      expression: "(*)-(*)-(*)-(*^[Branding,Business])-(*)-(*)"
    },
    {
      priority: 214,
      _id: "60422b53334ba439684e57cd",
      phase: "Achieve",
      level: 3,
      module: 1,
      title: "Digital Marketing with Facebook",
      link: "https://www.facebookblueprint.com/student/catalog",
      type: "ARTICLE",
      img: "https://revealbot.com/blog/content/images/2020/01/Blueprint-sg.png",
      expression: "(*)-(*)-(*)-(*^[Branding,Business])-(*)-(*)"
    },
    {
      priority: 215,
      _id: "60422b53334ba439684e57ce",
      phase: "Achieve",
      level: 3,
      module: 1,
      title: "Free Course with HubSpot",
      link: "https://academy.hubspot.com",
      type: "ARTICLE",
      img:
        "https://www.hubspot.com/hubfs/Academy%20Thumbnail%20for%20Resource%20Library.png",
      expression: "(*)-(*)-(*)-(*^[Branding,Business])-(*)-(*)"
    },
    {
      priority: 206,
      _id: "60433b6604b22d50bfe80b21",
      phase: "Achieve",
      level: 2,
      module: 1,
      title:
        "How to Build a Portfolio That'll Make Everyone Want to hire you |  The Muse",
      link:
        "https://www.themuse.com/advice/4-secrets-to-building-a-portfolio-thatll-make-everyone-want-to-hire-you",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRnxQ5Edjo4s1oa0_g_q24phvL6RVC8lwgmWg&usqp=CAU",
      expression: "(*)-(*)-(*)-(*^[Business])-(*)-(*)"
    },
    {
      priority: 210,
      _id: "6040ee5ccd0316041aca76f0",
      phase: "Achieve",
      level: 3,
      module: 1,
      title:
        "A Guide to Branding Yourself on Social Media - GRIN - Influencer Marketing Software",
      link:
        "https://grin.co/blog/a-guide-to-building-your-personal-brand-through-social-media/",
      type: "ARTICLE",
      img:
        "https://www.singlegrain.com/wp-content/uploads/2019/09/SG-The-Ultimate-Guide-to-Growing-Your-Business-with-Influencer-Marketing.jpg",
      expression: "(*)-(*)-(*)-(*^[Business])-(*)-(*)"
    },
    {
      priority: 211,
      _id: "60433b6604b22d50bfe80b23",
      phase: "Achieve",
      level: 3,
      module: 1,
      title: "9 Tips For Building Your Personal Brand On LinkedIn In 2019",
      link:
        "https://www.forbes.com/sites/ellevate/2019/06/26/9-tips-for-building-your-personal-brand-on-linkedin-in-2019/",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSbVjr2gbkAOrq8VX2PSQgsACfmZ3oq7Defxw&usqp=CAU",
      expression: "(*)-(*)-(*)-(*^[Business])-(*)-(*)"
    },
    {
      priority: 212,
      _id: "603e5154f73eb03cab3e6225",
      phase: "Achieve",
      level: 3,
      module: 1,
      title:
        "Mastering LinkedIn, The Personal Branding Epicenter of the Internet",
      link: "https://neilpatel.com/blog/mastering-linkedin/",
      type: "ARTICLE",
      img: "https://i.ytimg.com/vi/MiI-O2lSyLA/maxresdefault.jpg",
      expression: "(*)-(*)-(*)-(*^[Business])-(*)-(*)"
    },
    {
      priority: 216,
      _id: "6040ee5ccd0316041aca76f1",
      phase: "Achieve",
      level: 1,
      module: 2,
      title: "Top 5 Job Portals To Find Digital Marketing Jobs In India",
      link:
        "https://piidmpune.com/digital-marketing-jobs-internships-pune-portal/",
      type: "ARTICLE",
      img: "https://piidmpune.com/wp-content/uploads/2019/08/Indeed.png",
      expression: "(*)-(*)-(*)-(*/[Job,Promotion])-(*)-(*)"
    },
    {
      priority: 217,
      _id: "6040ee5ccd0316041aca76f2",
      phase: "Achieve",
      level: 1,
      module: 2,
      title: "LinkedIn Job Search Tutorial - How To Use LinkedIn To Find A Job",
      link: "https://www.youtube.com/watch?v=Ox_ohqsIMAM",
      type: "VIDEO",
      img: "https://img.youtube.com/vi/Ox_ohqsIMAM/default.jpg",
      expression: "(*)-(*)-(*)-(*/[Job,Promotion])-(*)-(*)"
    },
    {
      priority: 218,
      _id: "6040ee5ccd0316041aca76f3",
      phase: "Achieve",
      level: 1,
      module: 2,
      title: "10 excellent email examples for job hunters",
      link:
        "https://www.cnbc.com/2019/01/30/10-email-templates-every-successful-job-hunter-needs.html",
      type: "ARTICLE",
      img:
        "https://image.cnbcfm.com/api/v1/image/104668510-thumbnail2.jpg?v=1529476040?&w=720&h=405",
      expression: "(*)-(*)-(*)-(*/[Job,Promotion])-(*)-(*)"
    },
    {
      priority: 219,
      _id: "60433b6604b22d50bfe80b24",
      phase: "Achieve",
      level: 1,
      module: 2,
      title: "How to Make Your Cover Letter Stand Out",
      link:
        "https://www.thebalancecareers.com/get-your-cover-letter-noticed-2060153",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQZR2kmYyCeLM2LPXKXc2ooze0vICLMS_6m3Q&usqp=CAU",
      expression: "(*)-(*)-(*)-(*/[Job,Promotion])-(*)-(*)"
    },
    {
      priority: 220,
      _id: "60433b6604b22d50bfe80b25",
      phase: "Achieve",
      level: 1,
      module: 2,
      title: "How to Write a Great Job Application Email | Glassdoor Blog",
      link: "https://www.glassdoor.co.uk/blog/write-jobwinning-email-pitches/",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQQsMFprLZK0-I0UHyl25AqIBkaAynNgmU-Yw&usqp=CAU",
      expression: "(*)-(*)-(*)-(*/[Job,Promotion])-(*)-(*)"
    },
    {
      priority: 221,
      _id: "6040ee5ccd0316041aca76f4",
      phase: "Achieve",
      level: 1,
      module: 2,
      title:
        "How to Write a Follow-Up Email While Job Hunting [Templates + Tips]",
      link: "https://www.youtube.com/watch?v=9-kJDd6i3QE",
      type: "VIDEO",
      img:
        "https://i.pinimg.com/originals/49/b0/98/49b0984b39729fced6e2caefaaf5d535.jpg",
      expression: "(*)-(*)-(*)-(*/[Job,Promotion])-(*)-(*)"
    },
    {
      priority: 229,
      _id: "6040ee5dcd0316041aca76fa",
      phase: "Achieve",
      level: 1,
      module: 3,
      title: "How to Negotiate Salary: 37 Tips You Need to Know | The Muse",
      link:
        "https://www.themuse.com/advice/how-to-negotiate-salary-37-tips-you-need-to-know",
      type: "ARTICLE",
      img:
        "https://i.pinimg.com/originals/38/9c/67/389c67aa60e08e1116c6c3eec43fdefe.jpg",
      expression: "(*)-(*)-(*)-(*/[Job,Promotion])-(*)-(*)"
    },
    {
      priority: 230,
      _id: "60433b6604b22d50bfe80b2a",
      phase: "Achieve",
      level: 1,
      module: 3,
      title:
        "The Right Way to Follow Up After a Job Interview | 3 Tips | ZipRecruiter",
      link:
        "https://www.ziprecruiter.com/blog/the-right-way-to-follow-up-after-a-job-interview/#:~:text=After%20your%20job%20interview%2C%20the,24%20hours%20after%20the%20interview.",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSsScTqQhY0bUflMlrGl1ZuTWri9zoCK0697g&usqp=CAU",
      expression: "(*)-(*)-(*)-(*/[Job,Promotion])-(*)-(*)"
    },
    {
      priority: 223,
      _id: "60433b6604b22d50bfe80b29",
      phase: "Achieve",
      level: 1,
      module: 3,
      title: "Top 20 Common Job Interview Questions and Answers",
      link:
        "https://www.thebalancecareers.com/top-job-interview-questions-and-answers-2061226",
      type: "ARTICLE",
      img:
        "https://image.slidesharecdn.com/top20interviewquestionsandtheiranswersforfreshers-131009142723-phpapp01/95/top-20-interview-questions-and-their-answers-for-freshers-1-638.jpg?cb=1381329085",
      expression: "(*)-(*)-(*)-(*/[Job,Promotion,Business,Freelancing])-(*)-(*)"
    },
    {
      priority: 224,
      _id: "60422b53334ba439684e57cf",
      phase: "Achieve",
      level: 1,
      module: 3,
      title: "Digital Marketing Interview Question",
      link:
        "https://www.edureka.co/blog/interview-questions/digital-marketing-interview-questions/",
      type: "ARTICLE",
      img:
        "https://www.edureka.co/blog/wp-content/uploads/2019/09/Digital-Marketing-interview-questions-1.jpg",
      expression: "(*)-(*)-(*)-(*/[Job,Promotion,Business,Freelancing])-(*)-(*)"
    },
    {
      priority: 225,
      _id: "60422b53334ba439684e57d0",
      phase: "Achieve",
      level: 1,
      module: 3,
      title: "How to Ace Telephonic Interview",
      link: "https://youtu.be/XlLUlCaAq-g",
      type: "VIDEO",
      img: "undefined",
      expression: "(*)-(*)-(*)-(*/[Job,Freelancing])-(*)-(*)"
    },
    {
      priority: 226,
      _id: "6040ee5ccd0316041aca76f8",
      phase: "Achieve",
      level: 1,
      module: 3,
      title: "How to Answer: Tell Me About Yourself.",
      link: "https://www.youtube.com/watch?v=MmFuWmzeiDs",
      type: "VIDEO",
      img: "https://img.youtube.com/vi/MmFuWmzeiDs/default.jpg",
      expression: "(*)-(*)-(*)-(*/Job)-(*)-(*)"
    },
    {
      priority: 227,
      _id: "6040ee5ccd0316041aca76f9",
      phase: "Achieve",
      level: 1,
      module: 3,
      title: "What to Wear: The Best Job Interview Attire | Indeed.com",
      link:
        "https://in.indeed.com/career-advice/interviewing/what-to-wear-to-an-interview",
      type: "ARTICLE",
      img:
        "https://www.thebalancecareers.com/thmb/7KKsuwzcLCeV--O-w5oDiQkGEPk=/1000x1000/smart/filters:no_upscale()/interview-outfits-for-women-2061091_final1-5b731abbc9e77c0050999743.png",
      expression: "(*)-(*)-(*)-(*/Job)-(*)-(*)"
    },
    {
      priority: 228,
      _id: "60422b53334ba439684e57d1",
      phase: "Achieve",
      level: 1,
      module: 3,
      title: "Top 10 things you should never do in a job interview",
      link: "https://www.youtube.com/watch?v=3I5XcBs7xa8",
      type: "VIDEO",
      img: "undefined",
      expression: "(*)-(*)-(*)-(*/Job)-(*)-(*)"
    },
    {
      priority: 231,
      _id: "6040ee5dcd0316041aca76fd",
      phase: "Achieve",
      level: 1,
      module: 4,
      title:
        "What to Wear to Work - Tips for 4 Types of Office Dress Code Policies",
      link:
        "https://www.moneycrashers.com/what-wear-work-tips-office-dress-code/",
      type: "ARTICLE",
      img:
        "https://www.moneycrashers.com/wp-content/uploads/2015/01/office-business-professional-dress-1-810x455.jpg",
      expression: "(*)-(*)-(*)-(*/Job)-(*)-(*)"
    },
    {
      priority: 232,
      _id: "6040ee5dcd0316041aca76fe",
      phase: "Achieve",
      level: 1,
      module: 4,
      title: "5 Ways to Break the Ice With Your Colleagues As A New Employee",
      link:
        "https://www.careeraddict.com/5-ways-to-break-the-ice-with-your-colleagues-as-a-new-employee",
      type: "ARTICLE",
      img:
        "https://blog.vantagecircle.com/content/images/2020/07/Virtual-Team-building-activities.png",
      expression: "(*)-(*)-(*)-(*/Job)-(*)-(*)"
    },
    {
      priority: 233,
      _id: "60433b6604b22d50bfe80b2c",
      phase: "Achieve",
      level: 1,
      module: 4,
      title:
        "15 Things About Starting Your First Job I Wish Someone Had Told Me, So I'm Telling You",
      link: "https://www.buzzfeed.com/terripous/starting-your-first-job-advice",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRH4bFiG7CGC38BwxEqw6L2WRtLNLSoQxB-_A&usqp=CAU",
      expression: "(*)-(*)-(*)-(*/Job)-(*)-(*)"
    },
    {
      priority: 234,
      _id: "6040ee5dcd0316041aca76ff",
      phase: "Achieve",
      level: 1,
      module: 4,
      title: "8 Ways to Beat Loneliness in the Workplace",
      link: "https://www.youtube.com/watch?v=ODikODaycrg",
      type: "VIDEO",
      img: "https://img.youtube.com/vi/ODikODaycrg/default.jpg",
      expression: "(*)-(*)-(*)-(*/Job)-(*)-(*)"
    },
    {
      priority: 236,
      _id: "60433b6604b22d50bfe80b2d",
      phase: "Achieve",
      level: 1,
      module: 4,
      title: "Self-Management Skills Every Employee Needs to Have",
      link:
        "https://www.jobcluster.com/career-advice/self-management-skills-every-employee-needs-to-have-68",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQr6qwwvoZdtHKqnCCjwMeTcz3euYltdbZOiA&usqp=CAU",
      expression: "(*)-(*)-(*)-(*/Job)-(*)-(*)"
    },
    {
      priority: 238,
      _id: "60433b6604b22d50bfe80b20",
      phase: "Achieve",
      level: 1,
      module: 5,
      title: "The Ultimate Guide to Freelance Digital Marketing",
      link: "https://www.seoptimer.com/blog/freelance-digital-marketing/",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTb0e8-vytXY_z8001Hj51G21RIkUkQ3u7Mlg&usqp=CAU",
      expression: "(*)-(*)-(*)-(*/Freelancing)-(*)-(*)"
    },
    {
      priority: 239,
      _id: "6040ee5ccd0316041aca76ec",
      phase: "Achieve",
      level: 1,
      module: 5,
      title:
        "8 Incredible & Actionable Ways to Market Your Marketing Agency on Instagram in 2019 | Nomiscom WebDesign",
      link: "https://nomiscomwebdesign.eu/market-marketing-agency-instagram/",
      type: "ARTICLE",
      img: "https://i.ytimg.com/vi/vSp_p_IFY64/maxresdefault.jpg",
      expression: "(*)-(*)-(*)-(*/Freelancing)-(*)-(*)"
    },
    {
      priority: 240,
      _id: "6040ee5ccd0316041aca76ee",
      phase: "Achieve",
      level: 2,
      module: 5,
      title:
        "14 Personal Branding Tips for Aspiring Freelancers - Personal Branding Blog - Stand Out In Your Career",
      link:
        "https://www.personalbrandingblog.com/14-personal-branding-tips-aspiring-freelancers/",
      type: "ARTICLE",
      img:
        "https://images.ctfassets.net/q33z48p65a6w/rzoR5rlu7zZ6GTDBbJy79/962350c6c7c937fb6e9672715e990b47/Personal_Branding_Photo_by_Patrik_Michalicka.jpg?w=1200&h=645&fit=thumb",
      expression: "(*)-(*)-(*)-(*/Freelancing)-(*)-(*)"
    },
    {
      priority: 241,
      _id: "6040ee5ccd0316041aca76ef",
      phase: "Achieve",
      level: 2,
      module: 5,
      title:
        "6 Tips for getting started with freelance marketing (expert advice)",
      link: "https://www.iwillteachyoutoberich.com/blog/freelance-marketing/",
      type: "ARTICLE",
      img: "https://i.ytimg.com/vi/dEPFL7y_u_o/maxresdefault.jpg",
      expression: "(*)-(*)-(*)-(*/Freelancing)-(*)-(*)"
    },
    {
      priority: 242,
      _id: "6040ee5ccd0316041aca76f5",
      phase: "Achieve",
      level: 1,
      module: 6,
      title: "Marketing your Freelance Business",
      link: "https://www.fundera.com/blog/how-to-market-your-freelance-business",
      type: "ARTICLE",
      img:
        "https://assets-blog.fundera.com/assets/wp-content/uploads/2020/02/29094728/shutterstock_1039353907-1.jpg",
      expression: "(*)-(*)-(*)-(*/Freelancing)-(*)-(*)"
    },
    {
      priority: 243,
      _id: "6040ee5ccd0316041aca76f6",
      phase: "Achieve",
      level: 1,
      module: 6,
      title: "How To Make Money Online | Work From Home | Freelancing 101",
      link: "https://www.youtube.com/watch?v=V9v5Fd4qMA4",
      type: "VIDEO",
      img: "https://img.youtube.com/vi/V9v5Fd4qMA4/default.jpg",
      expression: "(*)-(*)-(*)-(*/Freelancing)-(*)-(*)"
    },
    {
      priority: 245,
      _id: "60433b6604b22d50bfe80b27",
      phase: "Achieve",
      level: 1,
      module: 6,
      title:
        "How Do I Get More Clients as a Freelancer in Digital Marketing? | by Anthony Pacheco | The Startup | Medium",
      link:
        "https://medium.com/swlh/how-do-i-get-more-clients-as-a-freelancer-in-digital-marketing-af5b4824c4f5",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQw-3w1uJhsvZWjBs9oRyqWGFAUCOv5jLWeg&usqp=CAU",
      expression: "(*)-(*)-(*)-(*/Freelancing)-(*)-(*)"
    },
    {
      priority: 246,
      _id: "60433b6604b22d50bfe80b28",
      phase: "Achieve",
      level: 1,
      module: 6,
      title: "How to find clients as a freelance digital marketer - Quora",
      link:
        "https://www.quora.com/How-do-you-find-clients-as-a-freelance-digital-marketer#:~:text=You%20can%20find%20a%20lot,are%20a%20lot%20of%20competitions.",
      type: "ARTICLE",
      img:
        "https://qph.fs.quoracdn.net/main-qimg-60c9c2cdc8d2e6e7322d2e8e45081dc0",
      expression: "(*)-(*)-(*)-(*/Freelancing)-(*)-(*)"
    },
    {
      priority: 247,
      _id: "6040ee5ccd0316041aca76f7",
      phase: "Achieve",
      level: 1,
      module: 6,
      title: "How to Write the Best Freelance Proposal (Free Template) in 2020",
      link: "https://www.ryrob.com/how-to-write-best-freelance-proposal/",
      type: "ARTICLE",
      img:
        "https://images.sampletemplates.com/wp-content/uploads/2016/06/21183822/Freelance-Proposal-Template-PDF.jpg",
      expression: "(*)-(*)-(*)-(*/Freelancing)-(*)-(*)"
    },
    {
      priority: 249,
      _id: "6040ee5dcd0316041aca76fb",
      phase: "Achieve",
      level: 1,
      module: 7,
      title: "Pricing 101 - Here's How To Price Yourself As A Freelancer",
      link: "https://careerfoundry.com/en/blog/career-change/pricing-freelancer/",
      type: "ARTICLE",
      img:
        "https://d33wubrfki0l68.cloudfront.net/79de8969543cbf9ef3358e906b6b29c4490aaee6/d1452/en/blog/uploads/freelancer-hourly-rate-pay.jpg",
      expression: "(*)-(*)-(*)-(*/Freelancing)-(*)-(*)"
    },
    {
      priority: 254,
      _id: "6040ee5dcd0316041aca7700",
      phase: "Achieve",
      level: 1,
      module: 8,
      title: "Freelance: How to Talk to Clients",
      link: "https://www.youtube.com/watch?v=L3MvE4eKnPo",
      type: "VIDEO",
      img: "https://img.youtube.com/vi/L3MvE4eKnPo/default.jpg",
      expression: "(*)-(*)-(*)-(*/Freelancing)-(*)-(*)"
    },
    {
      priority: 257,
      _id: "60422b53334ba439684e57d3",
      phase: "Achieve",
      level: 1,
      module: 8,
      title: "Financial Planning for freelancers",
      link: "https://www.tapchief.com/blog/financial-planning-freelancers/",
      type: "ARTICLE",
      img: "https://www.tapchief.com/assets/images/farewell-image.svg",
      expression: "(*)-(*)-(*)-(*/Freelancing)-(*)-(*)"
    },
    {
      priority: 251,
      _id: "6040ee5dcd0316041aca76fc",
      phase: "Achieve",
      level: 1,
      module: 7,
      title:
        "Negotiation 101: How to Negotiate With Clients - Constant Content (A Division of Moresby Media Inc.)",
      link:
        "https://www.constant-content.com/content-writing-service/2018/02/how-to-negotiate-with-clients/",
      type: "ARTICLE",
      img:
        "https://image.isu.pub/181204072938-c65d4420cf3f0d6e2e9b6c3c855ade37/jpg/page_1_thumb_large.jpg",
      expression: "(*)-(*)-(*)-(*/[Freelancing,Business,Branding])-(*)-(*)"
    },
    {
      priority: 252,
      _id: "60433b6604b22d50bfe80b2b",
      phase: "Achieve",
      level: 1,
      module: 7,
      title:
        "Freelance Business Sales: How To Close The Sale Before The Sales Call Begins",
      link: "https://jenniferbourn.com/close-the-sale/",
      type: "ARTICLE",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTZ_csDThP46vLAMruRu8ozLix0iczNw_eJwA&usqp=CAU",
      expression: "(*)-(*)-(*)-(*/[Freelancing,Business,Branding])-(*)-(*)"
    },
    {
      priority: 255,
      _id: "6040ee5dcd0316041aca7701",
      phase: "Achieve",
      level: 1,
      module: 8,
      title:
        "How to Maintain Client Relationships as a Freelancer | 3 Wise Bears Accountants",
      link:
        "https://www.3wisebears.co.uk/blog/how-to-maintain-client-relationships-as-a-freelancer/",
      type: "ARTICLE",
      img:
        "https://www.3wisebears.co.uk/wp-content/uploads/2018/11/contractor-issues-1-1-150x150.jpg",
      expression: "(*)-(*)-(*)-(*/[Freelancing,Branding])-(*)-(*)"
    },
    {
      priority: 256,
      _id: "60422b53334ba439684e57d2",
      phase: "Achieve",
      level: 1,
      module: 8,
      title: "How to get more Client Referrals",
      link: "https://www.youtube.com/watch?v=yrXoEaTO2mE&feature=emb_logo",
      type: "VIDEO",
      img: "undefined",
      expression:
        "(*)-(*)-(*)-OR(*/[Freelancing,Branding,Business])-OR(*/Agency)-(*)"
    }
  ];
  
  export default allContents;
  